/**
 * Extra translation keys — merged on top of translations.js at runtime.
 * Add new keys here; do not edit the main translations.js file.
 *
 * Generated shape: { lang: { group: { key: value } } }. Every language must
 * carry the same keys as `en`; missing keys silently fall back to the Italian
 * dictionary, which shows Italian text inside an otherwise translated UI.
 */
const extraTranslations = {
  it: {
    score_card: {
      label_not_run: "Non eseguito",
    },
    images: {
      studio_pill: "Studio di confronto",
      result_title: "Risultato ottimizzazione",
      result_sub: "Applicala su Shopify per mantenere il risparmio",
      result_grew_title: "Questa immagine è diventata più grande",
      result_grew_sub: "Il file di origine è più piccolo della dimensione target, quindi il resize lo ha ingrandito",
      result_before: "prima",
      result_after: "dopo",
      result_added: "Aggiunti",
      result_extra: "peso in più",
      result_freed: "liberati",
      result_output: "Output",
      result_no_compress: "nessuna compressione",
      results_processed: "elaborate",
      results_freed: "liberati",
      results_per_image: "per immagine",
      results_was: "era {{size}}",
      slider_fullscreen: "apri a schermo intero",
      info_pixels: "pixel",
      info_original: "originale",
      info_out_of: "su 100",
      info_awaiting_apply: "in attesa di applicazione",
      info_state: "ottimizzazione",
      status_todo: "Da ottimizzare",
      stat_not_scored: "non valutato",
      cta_n_images: "{{n}} immagini",
      cta_saving: "~{{size}} risparmiati",
      matches_in_block: "{{matches}} corrispondenti · {{scanned}} scansionati su {{total}}",
      block_info: "Blocco {{page}} di {{total}} · {{size}} prodotti ciascuno",
      client_filter_note: "Peso, orientamento e stato sono calcolati nel browser: filtrano il blocco caricato qui, non l'intero catalogo. Usa Succ per scansionare oltre.",
      meta_loading: "Lettura di altre {{n}} immagini — il conteggio si sta assestando",
      meta_unresolved: "{{n}} esclusi: dimensioni non disponibili",
      empty_title: "Seleziona un prodotto per confrontare",
      slider_hint: "Trascina la maniglia per confrontare",
      recommended: "Consigliato",
      size_unknown: "peso n/d",
      badge_optimized: "Ottimizzata",
      quality_small: "File più leggero",
      quality_best: "Qualità migliore",
      output_dims: "Output: {{dims}} px",
      output_quality: "qualità {{q}}%",
      saved_label: "Risparmiati",
      cta_est_saving: "~{{size}} risparmiati · nessun credito AI",
      cta_free: "Nessun credito AI utilizzato",
      stat_selected: "Selezionati",
      stat_n_images: "{{n}} immagini",
      stat_current: "Peso attuale",
      stat_partial: "{{k}} di {{n}} noti",
      stat_total: "totale",
      stat_after: "Dopo",
      stat_projected: "stimato",
      stat_no_baseline: "dopo il primo run",
      stat_saving: "Risparmio",
      stat_your_avg: "tua media",
      stat_no_data: "nessun dato",
      stat_saved_total: "Risparmiato finora",
      stat_n_ops: "{{n}} immagini",
      processing_title: "Ottimizzazione in corso…",
      processing_prep: "Preparazione…",
      processing_done: "{{done}} di {{total}} completate",
      processing_eta: "~{{time}} rimanenti",
      results_title: "Ottimizzazione completata",
      results_cancelled: "Esecuzione interrotta",
      results_sub: "Controlla i risultati, poi applicali su Shopify",
      results_images: "Immagini",
      results_saved: "Spazio risparmiato",
      results_avg: "Media",
      results_from_to: "Da → A",
      info_vendor: "Vendor",
      info_images: "Immagini",
      info_dims: "Dimensioni",
      info_weight: "Peso",
      info_seo: "SEO",
      info_status: "Stato",
      history_product: "Prodotto",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Anteprima traduzione",
      preview_hint: "Questo è il contenuto sorgente che verrà tradotto",
      from: "Da",
      to: "A",
      current: "Attuale",
      original: "Originale",
      ai_translation: "Traduzione AI",
      ai_working: "L'AI sta traducendo…",
      preparing: "Preparazione…",
      progress_line: "{{done}} di {{total}} elementi · {{fields}} campi ciascuno",
      translate_n: "Traduci {{n}}",
      translate_page: "Traduci {{n}} in {{lang}}",
      goto_page: "{{n}} selezionati — vai alla loro pagina",
      select_all_fields: "Seleziona tutti",
      deselect_fields: "Deseleziona",
      badge_translated: "Tradotto",
      not_selected: "non selezionato",
      empty_field: "Vuoto — verrà saltato",
      loading_detail: "Caricamento contenuto…",
      empty_title: "Seleziona un elemento per l'anteprima",
      n_items: "{{n}} elemento/i",
      n_fields: "{{n}} campi",
      stat_selected: "Selezionati",
      stat_target: "Lingua destinazione",
      stat_from: "da {{lang}}",
      stat_fields: "Campi",
      stat_per_item: "per elemento",
      stat_credits: "Crediti stimati",
      stat_credits_sub: "1 per elemento · cache gratis",
      stat_credits_na: "non conteggiati",
      stat_time: "Tempo stimato",
      stat_time_sub: "approssimativo",
      note_fields: "Campi SEO tradotti separatamente",
      note_cache: "In cache — le ripetizioni sono gratis",
      note_review: "Rivedi prima di pubblicare",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "Editor AI",
      current_version: "Versione attuale",
      ai_suggestion: "Suggerimento AI",
      generate_ai_btn: "Genera AI",
      regenerate_btn: "Rigenera",
      generate_field_title: "Genera questo campo con AI",
      apply_to_shopify: "Applica a Shopify",
      diff_legend: "Evidenziato = aggiunto o modificato dall'AI",
      unsaved_suggestions: "{{n}} suggerimento/i AI",
      field_limit: "max consigliato {{n}} caratteri",
      last_published: "Ultima pubblicazione",
      empty_title: "Seleziona un elemento per iniziare",
      stat_seo: "Punteggio SEO",
      stat_readability: "Leggibilità",
      stat_words: "Parole",
      stat_keywords: "Keywords",
      stat_fields: "Campi",
      stat_not_analyzed: "non analizzato",
      stat_wps: "{{n}} parole/frase",
      stat_no_text: "nessun testo",
      stat_in_description: "nella descrizione",
      stat_found: "trovate",
      stat_completed: "completati",
      read_easy: "Facile",
      read_medium: "Media",
      read_complex: "Complessa",
    },
    batch: {
      credits_exhausted_toast: "Crediti esauriti ({{used}}/{{limit}}) — acquista altri crediti o cambia piano",
      credits_exhausted_title: "Crediti AI esauriti",
      credits_exhausted_desc: "Hai utilizzato tutti i {{used}} dei tuoi {{limit}} crediti AI mensili. Acquista altri crediti o passa a un piano superiore per continuare a generare contenuti.",
      credits_buy_cta: "Acquista Crediti",
      credits_upgrade_cta: "Cambia Piano",
    },
    dashboard: {
      advisor_title: "AI Store Advisor",
      advisor_badge: "Generato automaticamente",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Ordinato per punteggio recuperabile",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Dove il tuo tempo rende di più",
      opportunity_tooltip: "L'impatto è relativo alla maggiore opportunità del tuo store, calcolato dalla formula del punteggio — non è una previsione assoluta di posizionamento.",
      opp_impact: "Impatto",
      opp_open: "Apri",
      opp_issues: "{{n}} problemi",
      opp_no_count: "a livello di sito",
      opp_meta_description: "Meta Description",
      opp_product_description: "Descrizione Prodotto",
      opp_alt_text: "ALT Text",
      opp_performance: "Ottimizzazione Velocità",
      opp_structured_data: "Dati Strutturati",
      opp_technical_seo: "SEO Tecnico",
      opp_ux: "Esperienza Utente",
      roi_very_high: "ROI molto alto",
      roi_high: "ROI alto",
      roi_medium: "ROI medio",
      roi_low: "ROI basso",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} è il principale fattore che limita il punteggio dello store ({{value}}/100).",
      insight_top_opportunity: "{{label}} è l'intervento con il maggiore impatto disponibile ora.",
      insight_strongest: "{{dim}} è già in ottimo stato ({{value}}/100) — nessun intervento necessario.",
      insight_alt: "L'accessibilità delle immagini può migliorare: {{n}} immagini non hanno ancora ALT text.",
      insight_top_three: "Risolvendo le prime tre opportunità il punteggio complessivo salirebbe di circa +{{n}} punti.",
      advisor_strong: "Il tuo store è tecnicamente in buona salute",
      advisor_weak_open: "Il tuo store ha margini di miglioramento su più fronti",
      advisor_blocked: "ma il Catalog Score ({{score}}/100) è limitato da",
      advisor_no_desc: "prodotti senza descrizione",
      advisor_no_meta: "prodotti senza meta description",
      advisor_no_alt: "immagini senza ALT text",
      advisor_advice: "Partire da qui vale almeno +{{gain}} punti di Catalog",
      advisor_clean: "Nessuna lacuna strutturale nel catalogo — continua così.",
      advisor_and: "e",
      advisor_cta: "Inizia da questo intervento",
      advisor_great_title: "Ottimo lavoro — il tuo store è ottimizzato",
      advisor_great_sub: "Nessuna lacuna strutturale rimasta. Rilancia l'audit dopo le prossime modifiche per mantenerlo così.",
      section_quickwins: "Quick Wins consigliati dall'AI",
      hint_quickwins: "Ordinati per impatto sullo score",
      priority_high: "alta",
      priority_medium: "media",
      priority_low: "bassa",
      gain_tooltip: "Guadagno minimo sul Catalog Score, dalla formula di calcolo. Generare contenuti di solito lo alza ancora.",
      eta_tooltip: "Stimato dalla velocità osservata",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} min",
      n_credits: "{{n}} crediti",
      no_credits: "nessun credito",
      fix_btn: "Risolvi",
      dim_technical: "SEO Tecnico",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Performance",
      dim_catalog: "Catalogo",
      perf_load: "Tempo di caricamento",
      perf_weight: "Peso pagina",
      perf_lazy: "Immagini lazy-load",
      perf_all: "tutte",
      perf_target: "obiettivo",
      credits_unlimited: "Illimitati",
      credits_left: "{{n}} crediti rimanenti",
      credits_exhausted: "Crediti mensili esauriti",
      credits_buy: "Ottieni altri crediti",
      forecast: "~{{n}}/mese al ritmo attuale",
      forecast_tooltip: "Estrapolato dal consumo dall'installazione",
      activity_empty: "Nessuna attività ancora",
      activity_fields: "campi",
      time_now: "adesso",
      time_min: "{{n}} min fa",
      time_hour: "{{n}}h fa",
      time_day: "{{n}}g fa",
      hero_cta_title: "Scopri i problemi SEO del tuo store",
      hero_cta_desc: "Avvia l'analisi completa: sincronizza i prodotti, calcola il punteggio SEO e ottieni l'Audit 360° in pochi minuti.",
      hero_cta_btn: "Inizia Analisi Gratuita",
      qw_missing_description_title: "{{n}} prodotti senza descrizione",
      qw_missing_description_desc: "Le descrizioni vuote penalizzano la SEO. Generale con l'AI.",
      qw_missing_meta_description_title: "{{n}} prodotti senza meta description",
      qw_missing_meta_description_desc: "Genera meta description SEO con l'AI per migliorare il CTR nei risultati di ricerca.",
      qw_missing_alt_text_title: "{{n}} immagini senza testo ALT",
      qw_missing_alt_text_desc: "Aggiungi il testo ALT alle immagini prodotto per SEO e accessibilità.",
      qw_missing_product_image_title: "{{n}} prodotti senza immagine",
      qw_missing_product_image_desc: "I prodotti senza immagine convertono molto meno. Aggiungine una.",
    },
    onboarding: {
      welcome_title: "Benvenuto su AI Optimizer 🎉",
      done_title: "Analisi completata ✅",
      running_title: "Analisi in corso…",
      store_connected: "Store {{domain}} connesso con successo.",
      skip_label: "Salta",
      intro_text: "Lascia che analizziamo automaticamente il tuo negozio per mostrarti i problemi SEO reali e come risolverli.",
      step1_title: "Sincronizzazione prodotti",
      step1_sub: "Importa il catalogo da Shopify",
      step2_title: "Analisi SEO prodotti",
      step2_sub: "Punteggio SEO per ogni prodotto",
      step3_title: "Audit Sito 360°",
      step3_sub: "SEO tecnico, UX, Trust, Performance",
      time_estimate: "Tempo stimato: 1–3 minuti in base alla dimensione del catalogo.",
      start_btn: "Inizia Analisi Gratuita",
      skip_btn: "Salta per ora — continua dalla dashboard",
      error_fallback: "Si è verificato un errore. Riprova dalla dashboard.",
      retry_btn: "Riprova",
      products_label: "prodotti",
      scanning: "Scansione in corso…",
      no_close: "Non chiudere questa finestra durante l'analisi",
      store_score_label: "Store Score",
      done_text: "La dashboard è ora popolata con i dati reali. Scopri i problemi e inizia ad ottimizzare.",
      see_results_btn: "Vedi Risultati",
    },
  },
  en: {
    score_card: {
      label_not_run: "Not run",
    },
    images: {
      studio_pill: "Comparison studio",
      result_title: "Optimization result",
      result_sub: "Apply it to Shopify to keep the saving",
      result_grew_title: "This image got bigger",
      result_grew_sub: "The source is smaller than the target size, so resizing upscaled it",
      result_before: "before",
      result_after: "after",
      result_added: "Added",
      result_extra: "extra weight",
      result_freed: "freed up",
      result_output: "Output",
      result_no_compress: "no compression",
      results_processed: "processed",
      results_freed: "freed up",
      results_per_image: "per image",
      results_was: "was {{size}}",
      slider_fullscreen: "open fullscreen",
      info_pixels: "pixels",
      info_original: "original",
      info_out_of: "out of 100",
      info_awaiting_apply: "awaiting apply",
      info_state: "optimization",
      status_todo: "To optimize",
      stat_not_scored: "not scored",
      cta_n_images: "{{n}} images",
      cta_saving: "~{{size}} saved",
      matches_in_block: "{{matches}} matching · {{scanned}} scanned of {{total}}",
      block_info: "Block {{page}} of {{total}} · {{size}} products each",
      client_filter_note: "Size, orientation and status are computed in your browser, so they filter the block loaded here — not the whole catalog. Use Next to scan further.",
      meta_loading: "Reading {{n}} more images — the count is still settling",
      meta_unresolved: "{{n}} excluded: dimensions unavailable",
      empty_title: "Select a product to compare",
      slider_hint: "Drag the handle to compare",
      recommended: "Recommended",
      size_unknown: "size n/a",
      badge_optimized: "Optimized",
      quality_small: "Smaller file",
      quality_best: "Best quality",
      output_dims: "Output: {{dims}} px",
      output_quality: "quality {{q}}%",
      saved_label: "Saved",
      cta_est_saving: "~{{size}} saved · no AI credits",
      cta_free: "No AI credits used",
      stat_selected: "Selected",
      stat_n_images: "{{n}} images",
      stat_current: "Current size",
      stat_partial: "{{k}} of {{n}} known",
      stat_total: "total",
      stat_after: "After",
      stat_projected: "projected",
      stat_no_baseline: "after first run",
      stat_saving: "Saving",
      stat_your_avg: "your average",
      stat_no_data: "no data yet",
      stat_saved_total: "Saved so far",
      stat_n_ops: "{{n}} images",
      processing_title: "Optimizing images…",
      processing_prep: "Preparing…",
      processing_done: "{{done}} of {{total}} completed",
      processing_eta: "~{{time}} left",
      results_title: "Optimization complete",
      results_cancelled: "Run stopped",
      results_sub: "Review the results, then apply them to Shopify",
      results_images: "Images",
      results_saved: "Space saved",
      results_avg: "Average",
      results_from_to: "From → To",
      info_vendor: "Vendor",
      info_images: "Images",
      info_dims: "Dimensions",
      info_weight: "Weight",
      info_seo: "SEO",
      info_status: "Status",
      history_product: "Product",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Translation preview",
      preview_hint: "This is the source content that will be translated",
      from: "From",
      to: "To",
      current: "Current",
      original: "Original",
      ai_translation: "AI Translation",
      ai_working: "AI is translating…",
      preparing: "Preparing…",
      progress_line: "{{done}} of {{total}} items · {{fields}} fields each",
      translate_n: "Translate {{n}}",
      translate_page: "Translate {{n}} into {{lang}}",
      goto_page: "{{n}} selected — go to their page",
      select_all_fields: "Select all",
      deselect_fields: "Deselect",
      badge_translated: "Translated",
      not_selected: "not selected",
      empty_field: "Empty — will be skipped",
      loading_detail: "Loading content…",
      empty_title: "Select an item to preview",
      n_items: "{{n}} item(s)",
      n_fields: "{{n}} fields",
      stat_selected: "Selected",
      stat_target: "Target Language",
      stat_from: "from {{lang}}",
      stat_fields: "Fields",
      stat_per_item: "per item",
      stat_credits: "Est. Credits",
      stat_credits_sub: "1 per item · cache free",
      stat_credits_na: "not metered",
      stat_time: "Est. Time",
      stat_time_sub: "approximate",
      note_fields: "SEO fields translated separately",
      note_cache: "Cached — re-runs are free",
      note_review: "Review before publishing",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "AI Editor",
      current_version: "Current version",
      ai_suggestion: "AI suggestion",
      generate_ai_btn: "Generate AI",
      regenerate_btn: "Regenerate",
      generate_field_title: "Generate this field with AI",
      apply_to_shopify: "Apply to Shopify",
      diff_legend: "Highlighted = added or changed by AI",
      unsaved_suggestions: "{{n}} AI suggestion(s)",
      field_limit: "recommended max {{n}} chars",
      last_published: "Last published",
      empty_title: "Select an item to start",
      stat_seo: "SEO Score",
      stat_readability: "Readability",
      stat_words: "Word Count",
      stat_keywords: "Keywords",
      stat_fields: "Fields",
      stat_not_analyzed: "not analyzed",
      stat_wps: "{{n}} words/sentence",
      stat_no_text: "no text",
      stat_in_description: "in description",
      stat_found: "found",
      stat_completed: "completed",
      read_easy: "Easy",
      read_medium: "Medium",
      read_complex: "Complex",
    },
    batch: {
      credits_exhausted_toast: "Credits exhausted ({{used}}/{{limit}}) — buy more or upgrade your plan",
      credits_exhausted_title: "AI credits exhausted",
      credits_exhausted_desc: "You have used all {{used}} of your {{limit}} monthly AI credits. Buy more credits or upgrade your plan to continue generating content.",
      credits_buy_cta: "Buy More Credits",
      credits_upgrade_cta: "Upgrade Plan",
    },
    dashboard: {
      advisor_title: "AI Store Advisor",
      advisor_badge: "Auto-generated",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Ranked by recoverable score",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Where your time pays off most",
      opportunity_tooltip: "Impact is relative to the largest opportunity on your store, computed from the score formula — not an absolute search-ranking claim.",
      opp_impact: "Impact",
      opp_open: "Open",
      opp_issues: "{{n}} issues",
      opp_no_count: "site-wide",
      opp_meta_description: "Meta Description",
      opp_product_description: "Product Description",
      opp_alt_text: "ALT Text",
      opp_performance: "Speed Optimization",
      opp_structured_data: "Structured Data",
      opp_technical_seo: "Technical SEO",
      opp_ux: "User Experience",
      roi_very_high: "Very high ROI",
      roi_high: "High ROI",
      roi_medium: "Medium ROI",
      roi_low: "Low ROI",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} is the main factor limiting your store score ({{value}}/100).",
      insight_top_opportunity: "{{label}} is the highest-impact intervention available right now.",
      insight_strongest: "{{dim}} is already in excellent shape ({{value}}/100) — no work needed there.",
      insight_alt: "Image accessibility can be improved: {{n}} images still have no ALT text.",
      insight_top_three: "Clearing the top three opportunities is worth roughly +{{n}} points of overall score.",
      advisor_strong: "Your store is technically in good shape",
      advisor_weak_open: "Your store has room to grow across the board",
      advisor_blocked: "but the Catalog score ({{score}}/100) is held back by",
      advisor_no_desc: "products without description",
      advisor_no_meta: "products without meta description",
      advisor_no_alt: "images without ALT text",
      advisor_advice: "Fixing this first is worth at least +{{gain}} Catalog points",
      advisor_clean: "No structural gaps left in the catalog — keep the momentum.",
      advisor_and: "and",
      advisor_cta: "Start with this fix",
      advisor_great_title: "Great job — your store is optimized",
      advisor_great_sub: "No structural gaps left. Re-run the audit after your next batch of changes to keep it that way.",
      section_quickwins: "AI Recommended Quick Wins",
      hint_quickwins: "Ranked by score impact",
      priority_high: "high",
      priority_medium: "medium",
      priority_low: "low",
      gain_tooltip: "Minimum gain on the Catalog score, from the scoring formula. Generating content usually lifts it further.",
      eta_tooltip: "Estimated from observed throughput",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} min",
      n_credits: "{{n}} credits",
      no_credits: "no credits",
      fix_btn: "Fix",
      dim_technical: "Technical SEO",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Performance",
      dim_catalog: "Catalog",
      perf_load: "Load time",
      perf_weight: "Page weight",
      perf_lazy: "Lazy-loaded images",
      perf_all: "all",
      perf_target: "target",
      credits_unlimited: "Unlimited",
      credits_left: "{{n}} credits remaining",
      credits_exhausted: "Monthly credits exhausted",
      credits_buy: "Get more credits",
      forecast: "~{{n}}/month at current pace",
      forecast_tooltip: "Extrapolated from your usage since install",
      activity_empty: "No activity yet",
      activity_fields: "fields",
      time_now: "just now",
      time_min: "{{n}} min ago",
      time_hour: "{{n}}h ago",
      time_day: "{{n}}d ago",
      hero_cta_title: "Discover your store's SEO issues",
      hero_cta_desc: "Start the full analysis: sync products, calculate the SEO score and get the 360° Audit in minutes.",
      hero_cta_btn: "Start Free Analysis",
      qw_missing_description_title: "{{n}} products without description",
      qw_missing_description_desc: "Empty descriptions hurt SEO. Generate them with AI.",
      qw_missing_meta_description_title: "{{n}} products without meta description",
      qw_missing_meta_description_desc: "Generate SEO meta descriptions with AI to improve search click-through.",
      qw_missing_alt_text_title: "{{n}} images without ALT text",
      qw_missing_alt_text_desc: "Add ALT text to product images for better SEO and accessibility.",
      qw_missing_product_image_title: "{{n}} products without an image",
      qw_missing_product_image_desc: "Products with no image convert far worse. Add one.",
    },
    onboarding: {
      welcome_title: "Welcome to AI Optimizer 🎉",
      done_title: "Analysis complete ✅",
      running_title: "Analysis in progress…",
      store_connected: "Store {{domain}} connected successfully.",
      skip_label: "Skip",
      intro_text: "Let us automatically analyze your store to show you real SEO issues and how to fix them.",
      step1_title: "Product sync",
      step1_sub: "Import catalog from Shopify",
      step2_title: "Product SEO analysis",
      step2_sub: "SEO score for each product",
      step3_title: "Site Audit 360°",
      step3_sub: "Technical SEO, UX, Trust, Performance",
      time_estimate: "Estimated time: 1–3 minutes depending on catalog size.",
      start_btn: "Start Free Analysis",
      skip_btn: "Skip for now — continue from dashboard",
      error_fallback: "An error occurred. Please retry from the dashboard.",
      retry_btn: "Retry",
      products_label: "products",
      scanning: "Scanning…",
      no_close: "Do not close this window during analysis",
      store_score_label: "Store Score",
      done_text: "The dashboard is now populated with real data. Discover the issues and start optimizing.",
      see_results_btn: "See Results",
    },
  },
  de: {
    score_card: {
      label_not_run: "Nicht ausgeführt",
    },
    batch: {
      credits_exhausted_toast: "Credits erschöpft ({{used}}/{{limit}}) — kaufe mehr oder wechsle deinen Plan",
      credits_exhausted_title: "KI-Credits erschöpft",
      credits_exhausted_desc: "Du hast alle {{used}} deiner {{limit}} monatlichen KI-Credits aufgebraucht. Kaufe mehr Credits oder wechsle zu einem höheren Plan, um weiter Inhalte zu generieren.",
      credits_buy_cta: "Mehr Credits kaufen",
      credits_upgrade_cta: "Plan upgraden",
    },
    dashboard: {
      hero_cta_title: "Entdecken Sie die SEO-Probleme Ihres Shops",
      hero_cta_desc: "Starten Sie die vollständige Analyse: Produkte synchronisieren, SEO-Score berechnen und den 360°-Audit in wenigen Minuten erhalten.",
      hero_cta_btn: "Kostenlose Analyse starten",
      advisor_title: "AI Store Advisor",
      advisor_badge: "Automatisch erstellt",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Nach erzielbarer Punktzahl sortiert",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Wo sich Ihre Zeit am meisten lohnt",
      opportunity_tooltip: "Die Wirkung ist relativ zur größten Chance in Ihrem Shop und stammt aus der Score-Formel — keine absolute Aussage über Suchrankings.",
      opp_impact: "Wirkung",
      opp_open: "Öffnen",
      opp_issues: "{{n}} Probleme",
      opp_no_count: "seitenweit",
      opp_meta_description: "Meta-Description",
      opp_product_description: "Produktbeschreibung",
      opp_alt_text: "ALT-Text",
      opp_performance: "Geschwindigkeitsoptimierung",
      opp_structured_data: "Strukturierte Daten",
      opp_technical_seo: "Technisches SEO",
      opp_ux: "Nutzererlebnis",
      roi_very_high: "Sehr hoher ROI",
      roi_high: "Hoher ROI",
      roi_medium: "Mittlerer ROI",
      roi_low: "Niedriger ROI",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} ist der Hauptfaktor, der Ihren Shop-Score begrenzt ({{value}}/100).",
      insight_top_opportunity: "{{label}} ist derzeit die Maßnahme mit der größten Wirkung.",
      insight_strongest: "{{dim}} ist bereits in ausgezeichnetem Zustand ({{value}}/100) — hier ist nichts zu tun.",
      insight_alt: "Die Bild-Barrierefreiheit lässt sich verbessern: {{n}} Bilder haben noch keinen ALT-Text.",
      insight_top_three: "Die drei größten Chancen zu schließen bringt rund +{{n}} Punkte Gesamtscore.",
      advisor_strong: "Ihr Shop ist technisch gut aufgestellt",
      advisor_weak_open: "Ihr Shop hat auf breiter Front Verbesserungspotenzial",
      advisor_blocked: "aber der Katalog-Score ({{score}}/100) wird gebremst von",
      advisor_no_desc: "Produkte ohne Beschreibung",
      advisor_no_meta: "Produkte ohne Meta-Description",
      advisor_no_alt: "Bilder ohne ALT-Text",
      advisor_advice: "Das zuerst zu beheben bringt mindestens +{{gain}} Katalog-Punkte",
      advisor_clean: "Keine strukturellen Lücken mehr im Katalog — weiter so.",
      advisor_and: "und",
      advisor_cta: "Mit dieser Maßnahme starten",
      advisor_great_title: "Gut gemacht — Ihr Shop ist optimiert",
      advisor_great_sub: "Keine strukturellen Lücken mehr. Führen Sie den Audit nach Ihren nächsten Änderungen erneut aus, damit es so bleibt.",
      section_quickwins: "Von der AI empfohlene Quick Wins",
      hint_quickwins: "Nach Score-Wirkung sortiert",
      priority_high: "hoch",
      priority_medium: "mittel",
      priority_low: "niedrig",
      gain_tooltip: "Mindestgewinn beim Katalog-Score laut Formel. Generierte Inhalte heben ihn meist noch weiter.",
      eta_tooltip: "Geschätzt aus dem beobachteten Durchsatz",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} Min.",
      n_credits: "{{n}} Credits",
      no_credits: "keine Credits",
      fix_btn: "Beheben",
      dim_technical: "Technisches SEO",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Performance",
      dim_catalog: "Katalog",
      perf_load: "Ladezeit",
      perf_weight: "Seitengewicht",
      perf_lazy: "Lazy-geladene Bilder",
      perf_all: "alle",
      perf_target: "Ziel",
      credits_unlimited: "Unbegrenzt",
      credits_left: "{{n}} Credits übrig",
      credits_exhausted: "Monatliche Credits aufgebraucht",
      credits_buy: "Mehr Credits holen",
      forecast: "~{{n}}/Monat beim aktuellen Tempo",
      forecast_tooltip: "Hochgerechnet aus Ihrem Verbrauch seit der Installation",
      activity_empty: "Noch keine Aktivität",
      activity_fields: "Felder",
      time_now: "gerade eben",
      time_min: "vor {{n}} Min.",
      time_hour: "vor {{n}} Std.",
      time_day: "vor {{n}} T.",
      qw_missing_description_title: "{{n}} Produkte ohne Beschreibung",
      qw_missing_description_desc: "Leere Beschreibungen schaden dem SEO. Mit AI generieren.",
      qw_missing_meta_description_title: "{{n}} Produkte ohne Meta-Description",
      qw_missing_meta_description_desc: "SEO-Meta-Descriptions mit AI generieren, um die Klickrate zu verbessern.",
      qw_missing_alt_text_title: "{{n}} Bilder ohne ALT-Text",
      qw_missing_alt_text_desc: "ALT-Text zu Produktbildern hinzufügen — für SEO und Barrierefreiheit.",
      qw_missing_product_image_title: "{{n}} Produkte ohne Bild",
      qw_missing_product_image_desc: "Produkte ohne Bild konvertieren deutlich schlechter. Fügen Sie eines hinzu.",
    },
    onboarding: {
      welcome_title: "Willkommen bei AI Optimizer 🎉",
      done_title: "Analyse abgeschlossen ✅",
      running_title: "Analyse läuft…",
      store_connected: "Shop {{domain}} erfolgreich verbunden.",
      skip_label: "Überspringen",
      intro_text: "Lassen Sie uns Ihren Shop automatisch analysieren, um echte SEO-Probleme und Lösungen aufzuzeigen.",
      step1_title: "Produktsynchronisation",
      step1_sub: "Katalog aus Shopify importieren",
      step2_title: "Produkt-SEO-Analyse",
      step2_sub: "SEO-Score für jedes Produkt",
      step3_title: "Website-Audit 360°",
      step3_sub: "Technisches SEO, UX, Trust, Performance",
      time_estimate: "Geschätzte Zeit: 1–3 Minuten je nach Kataloggröße.",
      start_btn: "Kostenlose Analyse starten",
      skip_btn: "Jetzt überspringen — weiter zum Dashboard",
      error_fallback: "Ein Fehler ist aufgetreten. Bitte vom Dashboard aus erneut versuchen.",
      retry_btn: "Erneut versuchen",
      products_label: "Produkte",
      scanning: "Scan läuft…",
      no_close: "Schließen Sie dieses Fenster während der Analyse nicht",
      store_score_label: "Store Score",
      done_text: "Das Dashboard ist jetzt mit echten Daten befüllt. Entdecken Sie die Probleme und beginnen Sie mit der Optimierung.",
      see_results_btn: "Ergebnisse anzeigen",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "AI-Editor",
      current_version: "Aktuelle Version",
      ai_suggestion: "AI-Vorschlag",
      generate_ai_btn: "AI generieren",
      regenerate_btn: "Neu generieren",
      generate_field_title: "Dieses Feld mit AI generieren",
      apply_to_shopify: "Auf Shopify anwenden",
      diff_legend: "Hervorgehoben = von der AI ergänzt oder geändert",
      unsaved_suggestions: "{{n}} AI-Vorschlag/-Vorschläge",
      field_limit: "empfohlen max. {{n}} Zeichen",
      last_published: "Zuletzt veröffentlicht",
      empty_title: "Wählen Sie ein Element aus",
      stat_seo: "SEO-Score",
      stat_readability: "Lesbarkeit",
      stat_words: "Wörter",
      stat_keywords: "Keywords",
      stat_fields: "Felder",
      stat_not_analyzed: "nicht analysiert",
      stat_wps: "{{n}} Wörter/Satz",
      stat_no_text: "kein Text",
      stat_in_description: "in der Beschreibung",
      stat_found: "gefunden",
      stat_completed: "ausgefüllt",
      read_easy: "Einfach",
      read_medium: "Mittel",
      read_complex: "Komplex",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Übersetzungsvorschau",
      preview_hint: "Dies ist der Quelltext, der übersetzt wird",
      from: "Von",
      to: "Nach",
      current: "Aktuell",
      original: "Original",
      ai_translation: "AI-Übersetzung",
      ai_working: "Die AI übersetzt…",
      preparing: "Vorbereitung…",
      progress_line: "{{done}} von {{total}} Elementen · je {{fields}} Felder",
      translate_n: "{{n}} übersetzen",
      translate_page: "{{n}} nach {{lang}} übersetzen",
      goto_page: "{{n}} ausgewählt — zu deren Seite wechseln",
      select_all_fields: "Alle auswählen",
      deselect_fields: "Abwählen",
      badge_translated: "Übersetzt",
      not_selected: "nicht ausgewählt",
      empty_field: "Leer — wird übersprungen",
      loading_detail: "Inhalt wird geladen…",
      empty_title: "Element für die Vorschau wählen",
      n_items: "{{n}} Element(e)",
      n_fields: "{{n}} Felder",
      stat_selected: "Ausgewählt",
      stat_target: "Zielsprache",
      stat_from: "aus {{lang}}",
      stat_fields: "Felder",
      stat_per_item: "pro Element",
      stat_credits: "Gesch. Credits",
      stat_credits_sub: "1 pro Element · Cache gratis",
      stat_credits_na: "nicht abgerechnet",
      stat_time: "Gesch. Dauer",
      stat_time_sub: "ungefähr",
      note_fields: "SEO-Felder werden einzeln übersetzt",
      note_cache: "Im Cache — Wiederholungen sind gratis",
      note_review: "Vor dem Veröffentlichen prüfen",
    },
    images: {
      studio_pill: "Vergleichsstudio",
      result_title: "Optimierungsergebnis",
      result_sub: "Wenden Sie es auf Shopify an, um die Ersparnis zu sichern",
      result_grew_title: "Dieses Bild wurde größer",
      result_grew_sub: "Die Quelle ist kleiner als die Zielgröße, das Skalieren hat sie vergrößert",
      result_before: "vorher",
      result_after: "nachher",
      result_added: "Hinzugefügt",
      result_extra: "Mehrgewicht",
      result_freed: "freigegeben",
      result_output: "Ausgabe",
      result_no_compress: "keine Komprimierung",
      results_processed: "verarbeitet",
      results_freed: "freigegeben",
      results_per_image: "pro Bild",
      results_was: "war {{size}}",
      slider_fullscreen: "Vollbild öffnen",
      info_pixels: "Pixel",
      info_original: "Original",
      info_out_of: "von 100",
      info_awaiting_apply: "wartet auf Anwendung",
      info_state: "Optimierung",
      status_todo: "Zu optimieren",
      stat_not_scored: "nicht bewertet",
      cta_n_images: "{{n}} Bilder",
      cta_saving: "~{{size}} gespart",
      matches_in_block: "{{matches}} Treffer · {{scanned}} von {{total}} geprüft",
      block_info: "Block {{page}} von {{total}} · je {{size}} Produkte",
      client_filter_note: "Größe, Ausrichtung und Status werden im Browser berechnet und filtern nur den hier geladenen Block, nicht den ganzen Katalog. Mit Weiter suchen Sie darüber hinaus.",
      meta_loading: "Weitere {{n}} Bilder werden gelesen — die Zahl stabilisiert sich noch",
      meta_unresolved: "{{n}} ausgeschlossen: Abmessungen nicht verfügbar",
      empty_title: "Produkt zum Vergleich auswählen",
      slider_hint: "Ziehen Sie den Griff zum Vergleichen",
      recommended: "Empfohlen",
      size_unknown: "Größe n. v.",
      badge_optimized: "Optimiert",
      quality_small: "Kleinere Datei",
      quality_best: "Beste Qualität",
      output_dims: "Ausgabe: {{dims}} px",
      output_quality: "Qualität {{q}} %",
      saved_label: "Gespart",
      cta_est_saving: "~{{size}} gespart · keine AI-Credits",
      cta_free: "Keine AI-Credits verbraucht",
      stat_selected: "Ausgewählt",
      stat_n_images: "{{n}} Bilder",
      stat_current: "Aktuelle Größe",
      stat_partial: "{{k}} von {{n}} bekannt",
      stat_total: "gesamt",
      stat_after: "Nachher",
      stat_projected: "geschätzt",
      stat_no_baseline: "nach dem ersten Lauf",
      stat_saving: "Ersparnis",
      stat_your_avg: "Ihr Durchschnitt",
      stat_no_data: "noch keine Daten",
      stat_saved_total: "Bisher gespart",
      stat_n_ops: "{{n}} Bilder",
      processing_title: "Bilder werden optimiert…",
      processing_prep: "Vorbereitung…",
      processing_done: "{{done}} von {{total}} fertig",
      processing_eta: "~{{time}} verbleibend",
      results_title: "Optimierung abgeschlossen",
      results_cancelled: "Lauf gestoppt",
      results_sub: "Ergebnisse prüfen und auf Shopify anwenden",
      results_images: "Bilder",
      results_saved: "Freigegebener Speicher",
      results_avg: "Durchschnitt",
      results_from_to: "Von → Zu",
      info_vendor: "Vendor",
      info_images: "Bilder",
      info_dims: "Abmessungen",
      info_weight: "Größe",
      info_seo: "SEO",
      info_status: "Status",
      history_product: "Produkt",
    },
  },
  fr: {
    score_card: {
      label_not_run: "Non effectué",
    },
    batch: {
      credits_exhausted_toast: "Crédits épuisés ({{used}}/{{limit}}) — achetez-en plus ou changez de plan",
      credits_exhausted_title: "Crédits IA épuisés",
      credits_exhausted_desc: "Vous avez utilisé tous vos {{used}} crédits IA mensuels sur {{limit}}. Achetez plus de crédits ou passez à un plan supérieur pour continuer à générer du contenu.",
      credits_buy_cta: "Acheter des crédits",
      credits_upgrade_cta: "Changer de plan",
    },
    dashboard: {
      hero_cta_title: "Découvrez les problèmes SEO de votre boutique",
      hero_cta_desc: "Lancez l'analyse complète : synchronisez les produits, calculez le score SEO et obtenez l'Audit 360° en quelques minutes.",
      hero_cta_btn: "Démarrer l'analyse gratuite",
      advisor_title: "AI Store Advisor",
      advisor_badge: "Généré automatiquement",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Classé par score récupérable",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Là où votre temps rapporte le plus",
      opportunity_tooltip: "L'impact est relatif à la plus grande opportunité de votre boutique, calculé depuis la formule du score — ce n'est pas une promesse de positionnement.",
      opp_impact: "Impact",
      opp_open: "Ouvrir",
      opp_issues: "{{n}} problèmes",
      opp_no_count: "sur tout le site",
      opp_meta_description: "Meta Description",
      opp_product_description: "Description produit",
      opp_alt_text: "Texte ALT",
      opp_performance: "Optimisation de la vitesse",
      opp_structured_data: "Données structurées",
      opp_technical_seo: "SEO technique",
      opp_ux: "Expérience utilisateur",
      roi_very_high: "ROI très élevé",
      roi_high: "ROI élevé",
      roi_medium: "ROI moyen",
      roi_low: "ROI faible",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} est le principal facteur qui limite le score de votre boutique ({{value}}/100).",
      insight_top_opportunity: "{{label}} est l'intervention au plus fort impact disponible actuellement.",
      insight_strongest: "{{dim}} est déjà en excellent état ({{value}}/100) — rien à faire de ce côté.",
      insight_alt: "L'accessibilité des images peut progresser : {{n}} images n'ont toujours pas de texte ALT.",
      insight_top_three: "Traiter les trois principales opportunités vaut environ +{{n}} points de score global.",
      advisor_strong: "Votre boutique est techniquement en bonne santé",
      advisor_weak_open: "Votre boutique a des marges de progression sur plusieurs fronts",
      advisor_blocked: "mais le score Catalogue ({{score}}/100) est freiné par",
      advisor_no_desc: "produits sans description",
      advisor_no_meta: "produits sans meta description",
      advisor_no_alt: "images sans texte ALT",
      advisor_advice: "Commencer par là vaut au moins +{{gain}} points de Catalogue",
      advisor_clean: "Plus aucune lacune structurelle dans le catalogue — continuez ainsi.",
      advisor_and: "et",
      advisor_cta: "Commencer par cette action",
      advisor_great_title: "Beau travail — votre boutique est optimisée",
      advisor_great_sub: "Plus aucune lacune structurelle. Relancez l'audit après vos prochaines modifications pour que cela dure.",
      section_quickwins: "Quick Wins recommandés par l'AI",
      hint_quickwins: "Classés par impact sur le score",
      priority_high: "haute",
      priority_medium: "moyenne",
      priority_low: "basse",
      gain_tooltip: "Gain minimal sur le score Catalogue, d'après la formule. Générer du contenu l'augmente généralement davantage.",
      eta_tooltip: "Estimé à partir du débit observé",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} min",
      n_credits: "{{n}} crédits",
      no_credits: "aucun crédit",
      fix_btn: "Corriger",
      dim_technical: "SEO technique",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Performance",
      dim_catalog: "Catalogue",
      perf_load: "Temps de chargement",
      perf_weight: "Poids de la page",
      perf_lazy: "Images en lazy-load",
      perf_all: "toutes",
      perf_target: "cible",
      credits_unlimited: "Illimités",
      credits_left: "{{n}} crédits restants",
      credits_exhausted: "Crédits mensuels épuisés",
      credits_buy: "Obtenir plus de crédits",
      forecast: "~{{n}}/mois au rythme actuel",
      forecast_tooltip: "Extrapolé depuis votre consommation depuis l'installation",
      activity_empty: "Aucune activité pour l'instant",
      activity_fields: "champs",
      time_now: "à l'instant",
      time_min: "il y a {{n}} min",
      time_hour: "il y a {{n}} h",
      time_day: "il y a {{n}} j",
      qw_missing_description_title: "{{n}} produits sans description",
      qw_missing_description_desc: "Les descriptions vides pénalisent le SEO. Générez-les avec l'AI.",
      qw_missing_meta_description_title: "{{n}} produits sans meta description",
      qw_missing_meta_description_desc: "Générez des meta descriptions SEO avec l'AI pour améliorer le taux de clic.",
      qw_missing_alt_text_title: "{{n}} images sans texte ALT",
      qw_missing_alt_text_desc: "Ajoutez du texte ALT aux images produit pour le SEO et l'accessibilité.",
      qw_missing_product_image_title: "{{n}} produits sans image",
      qw_missing_product_image_desc: "Les produits sans image convertissent bien moins. Ajoutez-en une.",
    },
    onboarding: {
      welcome_title: "Bienvenue sur AI Optimizer 🎉",
      done_title: "Analyse terminée ✅",
      running_title: "Analyse en cours…",
      store_connected: "Boutique {{domain}} connectée avec succès.",
      skip_label: "Ignorer",
      intro_text: "Laissez-nous analyser automatiquement votre boutique pour vous montrer les vrais problèmes SEO et comment les résoudre.",
      step1_title: "Synchronisation des produits",
      step1_sub: "Importer le catalogue depuis Shopify",
      step2_title: "Analyse SEO des produits",
      step2_sub: "Score SEO pour chaque produit",
      step3_title: "Audit Site 360°",
      step3_sub: "SEO technique, UX, Trust, Performance",
      time_estimate: "Temps estimé : 1 à 3 minutes selon la taille du catalogue.",
      start_btn: "Démarrer l'analyse gratuite",
      skip_btn: "Ignorer pour l'instant — continuer depuis le tableau de bord",
      error_fallback: "Une erreur s'est produite. Veuillez réessayer depuis le tableau de bord.",
      retry_btn: "Réessayer",
      products_label: "produits",
      scanning: "Analyse en cours…",
      no_close: "Ne fermez pas cette fenêtre pendant l'analyse",
      store_score_label: "Store Score",
      done_text: "Le tableau de bord est maintenant rempli avec de vraies données. Découvrez les problèmes et commencez à optimiser.",
      see_results_btn: "Voir les résultats",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "Éditeur AI",
      current_version: "Version actuelle",
      ai_suggestion: "Suggestion AI",
      generate_ai_btn: "Générer avec l'AI",
      regenerate_btn: "Régénérer",
      generate_field_title: "Générer ce champ avec l'AI",
      apply_to_shopify: "Appliquer à Shopify",
      diff_legend: "Surligné = ajouté ou modifié par l'AI",
      unsaved_suggestions: "{{n}} suggestion(s) AI",
      field_limit: "max recommandé {{n}} caractères",
      last_published: "Dernière publication",
      empty_title: "Sélectionnez un élément pour commencer",
      stat_seo: "Score SEO",
      stat_readability: "Lisibilité",
      stat_words: "Mots",
      stat_keywords: "Mots-clés",
      stat_fields: "Champs",
      stat_not_analyzed: "non analysé",
      stat_wps: "{{n}} mots/phrase",
      stat_no_text: "aucun texte",
      stat_in_description: "dans la description",
      stat_found: "trouvés",
      stat_completed: "complétés",
      read_easy: "Facile",
      read_medium: "Moyenne",
      read_complex: "Complexe",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Aperçu de traduction",
      preview_hint: "Voici le contenu source qui sera traduit",
      from: "De",
      to: "Vers",
      current: "Actuel",
      original: "Original",
      ai_translation: "Traduction AI",
      ai_working: "L'AI traduit…",
      preparing: "Préparation…",
      progress_line: "{{done}} sur {{total}} éléments · {{fields}} champs chacun",
      translate_n: "Traduire {{n}}",
      translate_page: "Traduire {{n}} en {{lang}}",
      goto_page: "{{n}} sélectionnés — aller à leur page",
      select_all_fields: "Tout sélectionner",
      deselect_fields: "Désélectionner",
      badge_translated: "Traduit",
      not_selected: "non sélectionné",
      empty_field: "Vide — sera ignoré",
      loading_detail: "Chargement du contenu…",
      empty_title: "Sélectionnez un élément pour l'aperçu",
      n_items: "{{n}} élément(s)",
      n_fields: "{{n}} champs",
      stat_selected: "Sélectionnés",
      stat_target: "Langue cible",
      stat_from: "depuis {{lang}}",
      stat_fields: "Champs",
      stat_per_item: "par élément",
      stat_credits: "Crédits estimés",
      stat_credits_sub: "1 par élément · cache gratuit",
      stat_credits_na: "non facturé",
      stat_time: "Durée estimée",
      stat_time_sub: "approximatif",
      note_fields: "Champs SEO traduits séparément",
      note_cache: "En cache — les répétitions sont gratuites",
      note_review: "Vérifiez avant de publier",
    },
    images: {
      studio_pill: "Studio de comparaison",
      result_title: "Résultat de l'optimisation",
      result_sub: "Appliquez-la à Shopify pour conserver le gain",
      result_grew_title: "Cette image est devenue plus lourde",
      result_grew_sub: "La source est plus petite que la taille cible, le redimensionnement l'a agrandie",
      result_before: "avant",
      result_after: "après",
      result_added: "Ajoutés",
      result_extra: "poids en plus",
      result_freed: "libérés",
      result_output: "Sortie",
      result_no_compress: "aucune compression",
      results_processed: "traitées",
      results_freed: "libérés",
      results_per_image: "par image",
      results_was: "était {{size}}",
      slider_fullscreen: "ouvrir en plein écran",
      info_pixels: "pixels",
      info_original: "original",
      info_out_of: "sur 100",
      info_awaiting_apply: "en attente d'application",
      info_state: "optimisation",
      status_todo: "À optimiser",
      stat_not_scored: "non évalué",
      cta_n_images: "{{n}} images",
      cta_saving: "~{{size}} économisés",
      matches_in_block: "{{matches}} correspondances · {{scanned}} sur {{total}} analysés",
      block_info: "Bloc {{page}} sur {{total}} · {{size}} produits chacun",
      client_filter_note: "Le poids, l'orientation et le statut sont calculés dans le navigateur : ils filtrent le bloc chargé ici, pas tout le catalogue. Utilisez Suivant pour aller plus loin.",
      meta_loading: "Lecture de {{n}} images supplémentaires — le décompte se stabilise",
      meta_unresolved: "{{n}} exclus : dimensions indisponibles",
      empty_title: "Sélectionnez un produit à comparer",
      slider_hint: "Faites glisser la poignée pour comparer",
      recommended: "Recommandé",
      size_unknown: "taille n/d",
      badge_optimized: "Optimisée",
      quality_small: "Fichier plus léger",
      quality_best: "Meilleure qualité",
      output_dims: "Sortie : {{dims}} px",
      output_quality: "qualité {{q}} %",
      saved_label: "Économisés",
      cta_est_saving: "~{{size}} économisés · aucun crédit AI",
      cta_free: "Aucun crédit AI utilisé",
      stat_selected: "Sélectionnés",
      stat_n_images: "{{n}} images",
      stat_current: "Poids actuel",
      stat_partial: "{{k}} sur {{n}} connus",
      stat_total: "total",
      stat_after: "Après",
      stat_projected: "estimé",
      stat_no_baseline: "après la première exécution",
      stat_saving: "Économie",
      stat_your_avg: "votre moyenne",
      stat_no_data: "aucune donnée",
      stat_saved_total: "Économisé à ce jour",
      stat_n_ops: "{{n}} images",
      processing_title: "Optimisation des images…",
      processing_prep: "Préparation…",
      processing_done: "{{done}} sur {{total}} terminées",
      processing_eta: "~{{time}} restantes",
      results_title: "Optimisation terminée",
      results_cancelled: "Exécution interrompue",
      results_sub: "Vérifiez les résultats puis appliquez-les à Shopify",
      results_images: "Images",
      results_saved: "Espace libéré",
      results_avg: "Moyenne",
      results_from_to: "De → À",
      info_vendor: "Vendeur",
      info_images: "Images",
      info_dims: "Dimensions",
      info_weight: "Poids",
      info_seo: "SEO",
      info_status: "Statut",
      history_product: "Produit",
    },
  },
  es: {
    score_card: {
      label_not_run: "No ejecutado",
    },
    batch: {
      credits_exhausted_toast: "Créditos agotados ({{used}}/{{limit}}) — compra más o mejora tu plan",
      credits_exhausted_title: "Créditos de IA agotados",
      credits_exhausted_desc: "Has utilizado los {{used}} de tus {{limit}} créditos de IA mensuales. Compra más créditos o mejora tu plan para seguir generando contenido.",
      credits_buy_cta: "Comprar más créditos",
      credits_upgrade_cta: "Mejorar plan",
    },
    dashboard: {
      hero_cta_title: "Descubre los problemas SEO de tu tienda",
      hero_cta_desc: "Inicia el análisis completo: sincroniza productos, calcula la puntuación SEO y obtén la Auditoría 360° en minutos.",
      hero_cta_btn: "Iniciar análisis gratuito",
      advisor_title: "AI Store Advisor",
      advisor_badge: "Generado automáticamente",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Ordenado por puntuación recuperable",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Donde tu tiempo rinde más",
      opportunity_tooltip: "El impacto es relativo a la mayor oportunidad de tu tienda, calculado con la fórmula de la puntuación — no es una promesa de posicionamiento.",
      opp_impact: "Impacto",
      opp_open: "Abrir",
      opp_issues: "{{n}} problemas",
      opp_no_count: "a nivel de sitio",
      opp_meta_description: "Meta Description",
      opp_product_description: "Descripción de producto",
      opp_alt_text: "Texto ALT",
      opp_performance: "Optimización de velocidad",
      opp_structured_data: "Datos estructurados",
      opp_technical_seo: "SEO técnico",
      opp_ux: "Experiencia de usuario",
      roi_very_high: "ROI muy alto",
      roi_high: "ROI alto",
      roi_medium: "ROI medio",
      roi_low: "ROI bajo",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} es el principal factor que limita la puntuación de tu tienda ({{value}}/100).",
      insight_top_opportunity: "{{label}} es la intervención de mayor impacto disponible ahora mismo.",
      insight_strongest: "{{dim}} ya está en excelente estado ({{value}}/100) — no hace falta trabajar ahí.",
      insight_alt: "La accesibilidad de las imágenes puede mejorar: {{n}} imágenes aún no tienen texto ALT.",
      insight_top_three: "Resolver las tres primeras oportunidades vale aproximadamente +{{n}} puntos de puntuación global.",
      advisor_strong: "Tu tienda está técnicamente en buen estado",
      advisor_weak_open: "Tu tienda tiene margen de mejora en varios frentes",
      advisor_blocked: "pero la puntuación de Catálogo ({{score}}/100) está limitada por",
      advisor_no_desc: "productos sin descripción",
      advisor_no_meta: "productos sin meta description",
      advisor_no_alt: "imágenes sin texto ALT",
      advisor_advice: "Empezar por aquí vale al menos +{{gain}} puntos de Catálogo",
      advisor_clean: "No quedan carencias estructurales en el catálogo — sigue así.",
      advisor_and: "y",
      advisor_cta: "Empezar por esta acción",
      advisor_great_title: "Buen trabajo — tu tienda está optimizada",
      advisor_great_sub: "No quedan carencias estructurales. Vuelve a ejecutar la auditoría tras tus próximos cambios para mantenerlo así.",
      section_quickwins: "Quick Wins recomendados por la AI",
      hint_quickwins: "Ordenados por impacto en la puntuación",
      priority_high: "alta",
      priority_medium: "media",
      priority_low: "baja",
      gain_tooltip: "Ganancia mínima en la puntuación de Catálogo, según la fórmula. Generar contenido suele elevarla aún más.",
      eta_tooltip: "Estimado a partir del rendimiento observado",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} min",
      n_credits: "{{n}} créditos",
      no_credits: "sin créditos",
      fix_btn: "Resolver",
      dim_technical: "SEO técnico",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Rendimiento",
      dim_catalog: "Catálogo",
      perf_load: "Tiempo de carga",
      perf_weight: "Peso de la página",
      perf_lazy: "Imágenes en lazy-load",
      perf_all: "todas",
      perf_target: "objetivo",
      credits_unlimited: "Ilimitados",
      credits_left: "{{n}} créditos restantes",
      credits_exhausted: "Créditos mensuales agotados",
      credits_buy: "Conseguir más créditos",
      forecast: "~{{n}}/mes al ritmo actual",
      forecast_tooltip: "Extrapolado de tu consumo desde la instalación",
      activity_empty: "Aún no hay actividad",
      activity_fields: "campos",
      time_now: "ahora mismo",
      time_min: "hace {{n}} min",
      time_hour: "hace {{n}} h",
      time_day: "hace {{n}} d",
      qw_missing_description_title: "{{n}} productos sin descripción",
      qw_missing_description_desc: "Las descripciones vacías perjudican el SEO. Genéralas con la AI.",
      qw_missing_meta_description_title: "{{n}} productos sin meta description",
      qw_missing_meta_description_desc: "Genera meta descriptions SEO con la AI para mejorar el CTR en búsquedas.",
      qw_missing_alt_text_title: "{{n}} imágenes sin texto ALT",
      qw_missing_alt_text_desc: "Añade texto ALT a las imágenes de producto para SEO y accesibilidad.",
      qw_missing_product_image_title: "{{n}} productos sin imagen",
      qw_missing_product_image_desc: "Los productos sin imagen convierten mucho peor. Añade una.",
    },
    onboarding: {
      welcome_title: "Bienvenido a AI Optimizer 🎉",
      done_title: "Análisis completado ✅",
      running_title: "Análisis en curso…",
      store_connected: "Tienda {{domain}} conectada con éxito.",
      skip_label: "Omitir",
      intro_text: "Permítenos analizar automáticamente tu tienda para mostrarte los problemas SEO reales y cómo resolverlos.",
      step1_title: "Sincronización de productos",
      step1_sub: "Importar catálogo desde Shopify",
      step2_title: "Análisis SEO de productos",
      step2_sub: "Puntuación SEO para cada producto",
      step3_title: "Auditoría del Sitio 360°",
      step3_sub: "SEO técnico, UX, Trust, Performance",
      time_estimate: "Tiempo estimado: 1–3 minutos según el tamaño del catálogo.",
      start_btn: "Iniciar análisis gratuito",
      skip_btn: "Omitir por ahora — continuar desde el panel",
      error_fallback: "Se produjo un error. Por favor, inténtalo de nuevo desde el panel.",
      retry_btn: "Reintentar",
      products_label: "productos",
      scanning: "Escaneando…",
      no_close: "No cierres esta ventana durante el análisis",
      store_score_label: "Store Score",
      done_text: "El panel ahora está poblado con datos reales. Descubre los problemas y empieza a optimizar.",
      see_results_btn: "Ver resultados",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "Editor AI",
      current_version: "Versión actual",
      ai_suggestion: "Sugerencia AI",
      generate_ai_btn: "Generar con AI",
      regenerate_btn: "Regenerar",
      generate_field_title: "Generar este campo con AI",
      apply_to_shopify: "Aplicar a Shopify",
      diff_legend: "Resaltado = añadido o modificado por la AI",
      unsaved_suggestions: "{{n}} sugerencia(s) AI",
      field_limit: "máx recomendado {{n}} caracteres",
      last_published: "Última publicación",
      empty_title: "Selecciona un elemento para empezar",
      stat_seo: "Puntuación SEO",
      stat_readability: "Legibilidad",
      stat_words: "Palabras",
      stat_keywords: "Keywords",
      stat_fields: "Campos",
      stat_not_analyzed: "sin analizar",
      stat_wps: "{{n}} palabras/frase",
      stat_no_text: "sin texto",
      stat_in_description: "en la descripción",
      stat_found: "encontradas",
      stat_completed: "completados",
      read_easy: "Fácil",
      read_medium: "Media",
      read_complex: "Compleja",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Vista previa de traducción",
      preview_hint: "Este es el contenido de origen que se traducirá",
      from: "De",
      to: "A",
      current: "Actual",
      original: "Original",
      ai_translation: "Traducción AI",
      ai_working: "La AI está traduciendo…",
      preparing: "Preparando…",
      progress_line: "{{done}} de {{total}} elementos · {{fields}} campos cada uno",
      translate_n: "Traducir {{n}}",
      translate_page: "Traducir {{n}} a {{lang}}",
      goto_page: "{{n}} seleccionados — ir a su página",
      select_all_fields: "Seleccionar todo",
      deselect_fields: "Deseleccionar",
      badge_translated: "Traducido",
      not_selected: "no seleccionado",
      empty_field: "Vacío — se omitirá",
      loading_detail: "Cargando contenido…",
      empty_title: "Selecciona un elemento para la vista previa",
      n_items: "{{n}} elemento(s)",
      n_fields: "{{n}} campos",
      stat_selected: "Seleccionados",
      stat_target: "Idioma destino",
      stat_from: "desde {{lang}}",
      stat_fields: "Campos",
      stat_per_item: "por elemento",
      stat_credits: "Créditos estimados",
      stat_credits_sub: "1 por elemento · caché gratis",
      stat_credits_na: "no contabilizado",
      stat_time: "Tiempo estimado",
      stat_time_sub: "aproximado",
      note_fields: "Campos SEO traducidos por separado",
      note_cache: "En caché — repetir es gratis",
      note_review: "Revisa antes de publicar",
    },
    images: {
      studio_pill: "Estudio de comparación",
      result_title: "Resultado de la optimización",
      result_sub: "Aplícala a Shopify para conservar el ahorro",
      result_grew_title: "Esta imagen se ha hecho más grande",
      result_grew_sub: "El original es menor que el tamaño objetivo, así que el redimensionado lo amplió",
      result_before: "antes",
      result_after: "después",
      result_added: "Añadidos",
      result_extra: "peso extra",
      result_freed: "liberados",
      result_output: "Salida",
      result_no_compress: "sin compresión",
      results_processed: "procesadas",
      results_freed: "liberados",
      results_per_image: "por imagen",
      results_was: "era {{size}}",
      slider_fullscreen: "abrir a pantalla completa",
      info_pixels: "píxeles",
      info_original: "original",
      info_out_of: "sobre 100",
      info_awaiting_apply: "pendiente de aplicar",
      info_state: "optimización",
      status_todo: "Por optimizar",
      stat_not_scored: "sin evaluar",
      cta_n_images: "{{n}} imágenes",
      cta_saving: "~{{size}} ahorrados",
      matches_in_block: "{{matches}} coincidencias · {{scanned}} de {{total}} analizados",
      block_info: "Bloque {{page}} de {{total}} · {{size}} productos cada uno",
      client_filter_note: "El peso, la orientación y el estado se calculan en el navegador: filtran el bloque cargado aquí, no todo el catálogo. Usa Siguiente para seguir explorando.",
      meta_loading: "Leyendo otras {{n}} imágenes — el recuento aún se está ajustando",
      meta_unresolved: "{{n}} excluidos: dimensiones no disponibles",
      empty_title: "Selecciona un producto para comparar",
      slider_hint: "Arrastra el control para comparar",
      recommended: "Recomendado",
      size_unknown: "peso n/d",
      badge_optimized: "Optimizada",
      quality_small: "Archivo más ligero",
      quality_best: "Mejor calidad",
      output_dims: "Salida: {{dims}} px",
      output_quality: "calidad {{q}} %",
      saved_label: "Ahorrados",
      cta_est_saving: "~{{size}} ahorrados · sin créditos AI",
      cta_free: "No se usan créditos AI",
      stat_selected: "Seleccionados",
      stat_n_images: "{{n}} imágenes",
      stat_current: "Peso actual",
      stat_partial: "{{k}} de {{n}} conocidos",
      stat_total: "total",
      stat_after: "Después",
      stat_projected: "estimado",
      stat_no_baseline: "tras la primera ejecución",
      stat_saving: "Ahorro",
      stat_your_avg: "tu media",
      stat_no_data: "sin datos",
      stat_saved_total: "Ahorrado hasta ahora",
      stat_n_ops: "{{n}} imágenes",
      processing_title: "Optimizando imágenes…",
      processing_prep: "Preparando…",
      processing_done: "{{done}} de {{total}} completadas",
      processing_eta: "~{{time}} restantes",
      results_title: "Optimización completada",
      results_cancelled: "Ejecución detenida",
      results_sub: "Revisa los resultados y aplícalos a Shopify",
      results_images: "Imágenes",
      results_saved: "Espacio liberado",
      results_avg: "Media",
      results_from_to: "De → A",
      info_vendor: "Proveedor",
      info_images: "Imágenes",
      info_dims: "Dimensiones",
      info_weight: "Peso",
      info_seo: "SEO",
      info_status: "Estado",
      history_product: "Producto",
    },
  },
  pt: {
    score_card: {
      label_not_run: "Não executado",
    },
    batch: {
      credits_exhausted_toast: "Créditos esgotados ({{used}}/{{limit}}) — compre mais ou mude de plano",
      credits_exhausted_title: "Créditos de IA esgotados",
      credits_exhausted_desc: "Você usou todos os {{used}} dos seus {{limit}} créditos de IA mensais. Compre mais créditos ou faça upgrade do plano para continuar gerando conteúdo.",
      credits_buy_cta: "Comprar mais créditos",
      credits_upgrade_cta: "Fazer upgrade",
    },
    dashboard: {
      hero_cta_title: "Descubra os problemas de SEO da sua loja",
      hero_cta_desc: "Inicie a análise completa: sincronize produtos, calcule a pontuação SEO e obtenha a Auditoria 360° em minutos.",
      hero_cta_btn: "Iniciar análise gratuita",
      advisor_title: "AI Store Advisor",
      advisor_badge: "Gerado automaticamente",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Ordenado por pontuação recuperável",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Onde o seu tempo rende mais",
      opportunity_tooltip: "O impacto é relativo à maior oportunidade da sua loja, calculado pela fórmula da pontuação — não é uma promessa de posicionamento.",
      opp_impact: "Impacto",
      opp_open: "Abrir",
      opp_issues: "{{n}} problemas",
      opp_no_count: "em todo o site",
      opp_meta_description: "Meta Description",
      opp_product_description: "Descrição do produto",
      opp_alt_text: "Texto ALT",
      opp_performance: "Otimização de velocidade",
      opp_structured_data: "Dados estruturados",
      opp_technical_seo: "SEO técnico",
      opp_ux: "Experiência do utilizador",
      roi_very_high: "ROI muito alto",
      roi_high: "ROI alto",
      roi_medium: "ROI médio",
      roi_low: "ROI baixo",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} é o principal fator que limita a pontuação da sua loja ({{value}}/100).",
      insight_top_opportunity: "{{label}} é a intervenção de maior impacto disponível agora.",
      insight_strongest: "{{dim}} já está em excelente estado ({{value}}/100) — não é preciso agir aí.",
      insight_alt: "A acessibilidade das imagens pode melhorar: {{n}} imagens ainda não têm texto ALT.",
      insight_top_three: "Resolver as três principais oportunidades vale cerca de +{{n}} pontos de pontuação geral.",
      advisor_strong: "A sua loja está tecnicamente em boa forma",
      advisor_weak_open: "A sua loja tem margem de melhoria em várias frentes",
      advisor_blocked: "mas a pontuação de Catálogo ({{score}}/100) está limitada por",
      advisor_no_desc: "produtos sem descrição",
      advisor_no_meta: "produtos sem meta description",
      advisor_no_alt: "imagens sem texto ALT",
      advisor_advice: "Começar por aqui vale pelo menos +{{gain}} pontos de Catálogo",
      advisor_clean: "Já não há lacunas estruturais no catálogo — continue assim.",
      advisor_and: "e",
      advisor_cta: "Começar por esta ação",
      advisor_great_title: "Bom trabalho — a sua loja está otimizada",
      advisor_great_sub: "Já não há lacunas estruturais. Execute a auditoria de novo após as próximas alterações para manter assim.",
      section_quickwins: "Quick Wins recomendados pela AI",
      hint_quickwins: "Ordenados por impacto na pontuação",
      priority_high: "alta",
      priority_medium: "média",
      priority_low: "baixa",
      gain_tooltip: "Ganho mínimo na pontuação de Catálogo, segundo a fórmula. Gerar conteúdo costuma elevá-la ainda mais.",
      eta_tooltip: "Estimado a partir do desempenho observado",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} min",
      n_credits: "{{n}} créditos",
      no_credits: "sem créditos",
      fix_btn: "Resolver",
      dim_technical: "SEO técnico",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Desempenho",
      dim_catalog: "Catálogo",
      perf_load: "Tempo de carregamento",
      perf_weight: "Peso da página",
      perf_lazy: "Imagens em lazy-load",
      perf_all: "todas",
      perf_target: "alvo",
      credits_unlimited: "Ilimitados",
      credits_left: "{{n}} créditos restantes",
      credits_exhausted: "Créditos mensais esgotados",
      credits_buy: "Obter mais créditos",
      forecast: "~{{n}}/mês ao ritmo atual",
      forecast_tooltip: "Extrapolado do seu consumo desde a instalação",
      activity_empty: "Ainda sem atividade",
      activity_fields: "campos",
      time_now: "agora mesmo",
      time_min: "há {{n}} min",
      time_hour: "há {{n}} h",
      time_day: "há {{n}} d",
      qw_missing_description_title: "{{n}} produtos sem descrição",
      qw_missing_description_desc: "Descrições vazias prejudicam o SEO. Gere-as com a AI.",
      qw_missing_meta_description_title: "{{n}} produtos sem meta description",
      qw_missing_meta_description_desc: "Gere meta descriptions SEO com a AI para melhorar o CTR nas pesquisas.",
      qw_missing_alt_text_title: "{{n}} imagens sem texto ALT",
      qw_missing_alt_text_desc: "Adicione texto ALT às imagens de produto para SEO e acessibilidade.",
      qw_missing_product_image_title: "{{n}} produtos sem imagem",
      qw_missing_product_image_desc: "Produtos sem imagem convertem muito pior. Adicione uma.",
    },
    onboarding: {
      welcome_title: "Bem-vindo ao AI Optimizer 🎉",
      done_title: "Análise concluída ✅",
      running_title: "Análise em andamento…",
      store_connected: "Loja {{domain}} conectada com sucesso.",
      skip_label: "Pular",
      intro_text: "Deixe-nos analisar automaticamente sua loja para mostrar os problemas de SEO reais e como resolvê-los.",
      step1_title: "Sincronização de produtos",
      step1_sub: "Importar catálogo do Shopify",
      step2_title: "Análise de SEO dos produtos",
      step2_sub: "Pontuação SEO para cada produto",
      step3_title: "Auditoria do Site 360°",
      step3_sub: "SEO técnico, UX, Trust, Performance",
      time_estimate: "Tempo estimado: 1 a 3 minutos dependendo do tamanho do catálogo.",
      start_btn: "Iniciar análise gratuita",
      skip_btn: "Pular por agora — continuar pelo painel",
      error_fallback: "Ocorreu um erro. Tente novamente pelo painel.",
      retry_btn: "Tentar novamente",
      products_label: "produtos",
      scanning: "Verificando…",
      no_close: "Não feche esta janela durante a análise",
      store_score_label: "Store Score",
      done_text: "O painel agora está preenchido com dados reais. Descubra os problemas e comece a otimizar.",
      see_results_btn: "Ver resultados",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "Editor AI",
      current_version: "Versão atual",
      ai_suggestion: "Sugestão AI",
      generate_ai_btn: "Gerar com AI",
      regenerate_btn: "Regenerar",
      generate_field_title: "Gerar este campo com AI",
      apply_to_shopify: "Aplicar ao Shopify",
      diff_legend: "Destacado = adicionado ou alterado pela AI",
      unsaved_suggestions: "{{n}} sugestão(ões) AI",
      field_limit: "máx recomendado {{n}} caracteres",
      last_published: "Última publicação",
      empty_title: "Selecione um elemento para começar",
      stat_seo: "Pontuação SEO",
      stat_readability: "Legibilidade",
      stat_words: "Palavras",
      stat_keywords: "Keywords",
      stat_fields: "Campos",
      stat_not_analyzed: "não analisado",
      stat_wps: "{{n}} palavras/frase",
      stat_no_text: "sem texto",
      stat_in_description: "na descrição",
      stat_found: "encontradas",
      stat_completed: "preenchidos",
      read_easy: "Fácil",
      read_medium: "Média",
      read_complex: "Complexa",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Pré-visualização da tradução",
      preview_hint: "Este é o conteúdo de origem que será traduzido",
      from: "De",
      to: "Para",
      current: "Atual",
      original: "Original",
      ai_translation: "Tradução AI",
      ai_working: "A AI está a traduzir…",
      preparing: "A preparar…",
      progress_line: "{{done}} de {{total}} elementos · {{fields}} campos cada",
      translate_n: "Traduzir {{n}}",
      translate_page: "Traduzir {{n}} para {{lang}}",
      goto_page: "{{n}} selecionados — ir para a sua página",
      select_all_fields: "Selecionar tudo",
      deselect_fields: "Desselecionar",
      badge_translated: "Traduzido",
      not_selected: "não selecionado",
      empty_field: "Vazio — será ignorado",
      loading_detail: "A carregar conteúdo…",
      empty_title: "Selecione um elemento para pré-visualizar",
      n_items: "{{n}} elemento(s)",
      n_fields: "{{n}} campos",
      stat_selected: "Selecionados",
      stat_target: "Idioma de destino",
      stat_from: "de {{lang}}",
      stat_fields: "Campos",
      stat_per_item: "por elemento",
      stat_credits: "Créditos estimados",
      stat_credits_sub: "1 por elemento · cache grátis",
      stat_credits_na: "não contabilizado",
      stat_time: "Tempo estimado",
      stat_time_sub: "aproximado",
      note_fields: "Campos SEO traduzidos separadamente",
      note_cache: "Em cache — repetições são grátis",
      note_review: "Reveja antes de publicar",
    },
    images: {
      studio_pill: "Estúdio de comparação",
      result_title: "Resultado da otimização",
      result_sub: "Aplique-a ao Shopify para manter a poupança",
      result_grew_title: "Esta imagem ficou maior",
      result_grew_sub: "A origem é menor do que o tamanho alvo, por isso o redimensionamento ampliou-a",
      result_before: "antes",
      result_after: "depois",
      result_added: "Adicionados",
      result_extra: "peso extra",
      result_freed: "libertados",
      result_output: "Saída",
      result_no_compress: "sem compressão",
      results_processed: "processadas",
      results_freed: "libertados",
      results_per_image: "por imagem",
      results_was: "era {{size}}",
      slider_fullscreen: "abrir em ecrã inteiro",
      info_pixels: "píxeis",
      info_original: "original",
      info_out_of: "em 100",
      info_awaiting_apply: "a aguardar aplicação",
      info_state: "otimização",
      status_todo: "Por otimizar",
      stat_not_scored: "não avaliado",
      cta_n_images: "{{n}} imagens",
      cta_saving: "~{{size}} poupados",
      matches_in_block: "{{matches}} correspondências · {{scanned}} de {{total}} analisados",
      block_info: "Bloco {{page}} de {{total}} · {{size}} produtos cada",
      client_filter_note: "O peso, a orientação e o estado são calculados no browser: filtram o bloco carregado aqui, não todo o catálogo. Use Seguinte para continuar.",
      meta_loading: "A ler mais {{n}} imagens — a contagem ainda está a estabilizar",
      meta_unresolved: "{{n}} excluídos: dimensões indisponíveis",
      empty_title: "Selecione um produto para comparar",
      slider_hint: "Arraste o manípulo para comparar",
      recommended: "Recomendado",
      size_unknown: "peso n/d",
      badge_optimized: "Otimizada",
      quality_small: "Ficheiro mais leve",
      quality_best: "Melhor qualidade",
      output_dims: "Saída: {{dims}} px",
      output_quality: "qualidade {{q}} %",
      saved_label: "Poupados",
      cta_est_saving: "~{{size}} poupados · sem créditos AI",
      cta_free: "Nenhum crédito AI utilizado",
      stat_selected: "Selecionados",
      stat_n_images: "{{n}} imagens",
      stat_current: "Peso atual",
      stat_partial: "{{k}} de {{n}} conhecidos",
      stat_total: "total",
      stat_after: "Depois",
      stat_projected: "estimado",
      stat_no_baseline: "após a primeira execução",
      stat_saving: "Poupança",
      stat_your_avg: "a sua média",
      stat_no_data: "sem dados",
      stat_saved_total: "Poupado até agora",
      stat_n_ops: "{{n}} imagens",
      processing_title: "A otimizar imagens…",
      processing_prep: "A preparar…",
      processing_done: "{{done}} de {{total}} concluídas",
      processing_eta: "~{{time}} em falta",
      results_title: "Otimização concluída",
      results_cancelled: "Execução interrompida",
      results_sub: "Verifique os resultados e aplique-os ao Shopify",
      results_images: "Imagens",
      results_saved: "Espaço libertado",
      results_avg: "Média",
      results_from_to: "De → Para",
      info_vendor: "Fornecedor",
      info_images: "Imagens",
      info_dims: "Dimensões",
      info_weight: "Peso",
      info_seo: "SEO",
      info_status: "Estado",
      history_product: "Produto",
    },
  },
  nl: {
    score_card: {
      label_not_run: "Niet uitgevoerd",
    },
    batch: {
      credits_exhausted_toast: "Credits uitgeput ({{used}}/{{limit}}) — koop meer of upgrade je plan",
      credits_exhausted_title: "AI-credits uitgeput",
      credits_exhausted_desc: "Je hebt alle {{used}} van je {{limit}} maandelijkse AI-credits gebruikt. Koop meer credits of upgrade je plan om door te gaan met het genereren van content.",
      credits_buy_cta: "Meer credits kopen",
      credits_upgrade_cta: "Plan upgraden",
    },
    dashboard: {
      hero_cta_title: "Ontdek de SEO-problemen van uw winkel",
      hero_cta_desc: "Start de volledige analyse: synchroniseer producten, bereken de SEO-score en ontvang de 360°-audit in enkele minuten.",
      hero_cta_btn: "Gratis analyse starten",
      advisor_title: "AI Store Advisor",
      advisor_badge: "Automatisch gegenereerd",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Gesorteerd op terugwinbare score",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Waar uw tijd het meest oplevert",
      opportunity_tooltip: "De impact is relatief ten opzichte van de grootste kans in uw winkel, berekend met de scoreformule — geen absolute belofte over zoekposities.",
      opp_impact: "Impact",
      opp_open: "Openen",
      opp_issues: "{{n}} problemen",
      opp_no_count: "sitebreed",
      opp_meta_description: "Meta Description",
      opp_product_description: "Productbeschrijving",
      opp_alt_text: "ALT-tekst",
      opp_performance: "Snelheidsoptimalisatie",
      opp_structured_data: "Gestructureerde data",
      opp_technical_seo: "Technische SEO",
      opp_ux: "Gebruikerservaring",
      roi_very_high: "Zeer hoge ROI",
      roi_high: "Hoge ROI",
      roi_medium: "Gemiddelde ROI",
      roi_low: "Lage ROI",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} is de belangrijkste factor die uw winkelscore beperkt ({{value}}/100).",
      insight_top_opportunity: "{{label}} is op dit moment de ingreep met de grootste impact.",
      insight_strongest: "{{dim}} is al in uitstekende staat ({{value}}/100) — daar is niets te doen.",
      insight_alt: "De toegankelijkheid van afbeeldingen kan beter: {{n}} afbeeldingen hebben nog geen ALT-tekst.",
      insight_top_three: "De top drie kansen wegwerken is ongeveer +{{n}} punten totaalscore waard.",
      advisor_strong: "Uw winkel is technisch in goede staat",
      advisor_weak_open: "Uw winkel heeft op meerdere vlakken ruimte om te groeien",
      advisor_blocked: "maar de Catalogus-score ({{score}}/100) wordt geremd door",
      advisor_no_desc: "producten zonder beschrijving",
      advisor_no_meta: "producten zonder meta description",
      advisor_no_alt: "afbeeldingen zonder ALT-tekst",
      advisor_advice: "Hiermee beginnen levert minstens +{{gain}} Catalogus-punten op",
      advisor_clean: "Geen structurele gaten meer in de catalogus — ga zo door.",
      advisor_and: "en",
      advisor_cta: "Begin met deze actie",
      advisor_great_title: "Goed gedaan — uw winkel is geoptimaliseerd",
      advisor_great_sub: "Geen structurele gaten meer. Voer de audit opnieuw uit na uw volgende wijzigingen om dat zo te houden.",
      section_quickwins: "Door AI aanbevolen Quick Wins",
      hint_quickwins: "Gesorteerd op score-impact",
      priority_high: "hoog",
      priority_medium: "gemiddeld",
      priority_low: "laag",
      gain_tooltip: "Minimale winst op de Catalogus-score volgens de formule. Content genereren tilt hem meestal verder op.",
      eta_tooltip: "Geschat op basis van de waargenomen doorvoer",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} min",
      n_credits: "{{n}} credits",
      no_credits: "geen credits",
      fix_btn: "Oplossen",
      dim_technical: "Technische SEO",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Performance",
      dim_catalog: "Catalogus",
      perf_load: "Laadtijd",
      perf_weight: "Paginagewicht",
      perf_lazy: "Lazy-geladen afbeeldingen",
      perf_all: "alle",
      perf_target: "doel",
      credits_unlimited: "Onbeperkt",
      credits_left: "{{n}} credits over",
      credits_exhausted: "Maandelijkse credits op",
      credits_buy: "Meer credits halen",
      forecast: "~{{n}}/maand bij het huidige tempo",
      forecast_tooltip: "Geëxtrapoleerd uit uw verbruik sinds installatie",
      activity_empty: "Nog geen activiteit",
      activity_fields: "velden",
      time_now: "zojuist",
      time_min: "{{n}} min geleden",
      time_hour: "{{n}} u geleden",
      time_day: "{{n}} d geleden",
      qw_missing_description_title: "{{n}} producten zonder beschrijving",
      qw_missing_description_desc: "Lege beschrijvingen schaden de SEO. Genereer ze met AI.",
      qw_missing_meta_description_title: "{{n}} producten zonder meta description",
      qw_missing_meta_description_desc: "Genereer SEO meta descriptions met AI voor een betere doorklikratio.",
      qw_missing_alt_text_title: "{{n}} afbeeldingen zonder ALT-tekst",
      qw_missing_alt_text_desc: "Voeg ALT-tekst toe aan productafbeeldingen voor SEO en toegankelijkheid.",
      qw_missing_product_image_title: "{{n}} producten zonder afbeelding",
      qw_missing_product_image_desc: "Producten zonder afbeelding converteren veel slechter. Voeg er een toe.",
    },
    onboarding: {
      welcome_title: "Welkom bij AI Optimizer 🎉",
      done_title: "Analyse voltooid ✅",
      running_title: "Analyse bezig…",
      store_connected: "Winkel {{domain}} succesvol verbonden.",
      skip_label: "Overslaan",
      intro_text: "Laat ons uw winkel automatisch analyseren om echte SEO-problemen en oplossingen te tonen.",
      step1_title: "Productsynchronisatie",
      step1_sub: "Catalogus importeren vanuit Shopify",
      step2_title: "SEO-analyse van producten",
      step2_sub: "SEO-score voor elk product",
      step3_title: "Site-audit 360°",
      step3_sub: "Technische SEO, UX, Trust, Performance",
      time_estimate: "Geschatte tijd: 1–3 minuten afhankelijk van de catalogusgrootte.",
      start_btn: "Gratis analyse starten",
      skip_btn: "Nu overslaan — doorgaan vanuit het dashboard",
      error_fallback: "Er is een fout opgetreden. Probeer het opnieuw vanuit het dashboard.",
      retry_btn: "Opnieuw proberen",
      products_label: "producten",
      scanning: "Scannen…",
      no_close: "Sluit dit venster niet tijdens de analyse",
      store_score_label: "Store Score",
      done_text: "Het dashboard is nu gevuld met echte gegevens. Ontdek de problemen en begin met optimaliseren.",
      see_results_btn: "Resultaten bekijken",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "AI-editor",
      current_version: "Huidige versie",
      ai_suggestion: "AI-suggestie",
      generate_ai_btn: "Genereer met AI",
      regenerate_btn: "Opnieuw genereren",
      generate_field_title: "Dit veld met AI genereren",
      apply_to_shopify: "Toepassen op Shopify",
      diff_legend: "Gemarkeerd = toegevoegd of gewijzigd door de AI",
      unsaved_suggestions: "{{n}} AI-suggestie(s)",
      field_limit: "aanbevolen max. {{n}} tekens",
      last_published: "Laatst gepubliceerd",
      empty_title: "Selecteer een item om te beginnen",
      stat_seo: "SEO-score",
      stat_readability: "Leesbaarheid",
      stat_words: "Woorden",
      stat_keywords: "Keywords",
      stat_fields: "Velden",
      stat_not_analyzed: "niet geanalyseerd",
      stat_wps: "{{n}} woorden/zin",
      stat_no_text: "geen tekst",
      stat_in_description: "in de beschrijving",
      stat_found: "gevonden",
      stat_completed: "ingevuld",
      read_easy: "Makkelijk",
      read_medium: "Gemiddeld",
      read_complex: "Complex",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Vertaalvoorbeeld",
      preview_hint: "Dit is de brontekst die vertaald wordt",
      from: "Van",
      to: "Naar",
      current: "Huidig",
      original: "Origineel",
      ai_translation: "AI-vertaling",
      ai_working: "De AI vertaalt…",
      preparing: "Voorbereiden…",
      progress_line: "{{done}} van {{total}} items · {{fields}} velden elk",
      translate_n: "{{n}} vertalen",
      translate_page: "{{n}} naar {{lang}} vertalen",
      goto_page: "{{n}} geselecteerd — ga naar hun pagina",
      select_all_fields: "Alles selecteren",
      deselect_fields: "Deselecteren",
      badge_translated: "Vertaald",
      not_selected: "niet geselecteerd",
      empty_field: "Leeg — wordt overgeslagen",
      loading_detail: "Inhoud laden…",
      empty_title: "Selecteer een item voor het voorbeeld",
      n_items: "{{n}} item(s)",
      n_fields: "{{n}} velden",
      stat_selected: "Geselecteerd",
      stat_target: "Doeltaal",
      stat_from: "vanuit {{lang}}",
      stat_fields: "Velden",
      stat_per_item: "per item",
      stat_credits: "Gesch. credits",
      stat_credits_sub: "1 per item · cache gratis",
      stat_credits_na: "niet afgerekend",
      stat_time: "Gesch. tijd",
      stat_time_sub: "bij benadering",
      note_fields: "SEO-velden apart vertaald",
      note_cache: "In cache — herhalen is gratis",
      note_review: "Controleer voor publicatie",
    },
    images: {
      studio_pill: "Vergelijkingsstudio",
      result_title: "Optimalisatieresultaat",
      result_sub: "Pas het toe op Shopify om de besparing te behouden",
      result_grew_title: "Deze afbeelding is groter geworden",
      result_grew_sub: "De bron is kleiner dan het doelformaat, dus het schalen heeft hem vergroot",
      result_before: "voor",
      result_after: "na",
      result_added: "Toegevoegd",
      result_extra: "extra gewicht",
      result_freed: "vrijgemaakt",
      result_output: "Uitvoer",
      result_no_compress: "geen compressie",
      results_processed: "verwerkt",
      results_freed: "vrijgemaakt",
      results_per_image: "per afbeelding",
      results_was: "was {{size}}",
      slider_fullscreen: "volledig scherm openen",
      info_pixels: "pixels",
      info_original: "origineel",
      info_out_of: "van 100",
      info_awaiting_apply: "wacht op toepassen",
      info_state: "optimalisatie",
      status_todo: "Te optimaliseren",
      stat_not_scored: "niet beoordeeld",
      cta_n_images: "{{n}} afbeeldingen",
      cta_saving: "~{{size}} bespaard",
      matches_in_block: "{{matches}} treffers · {{scanned}} van {{total}} doorzocht",
      block_info: "Blok {{page}} van {{total}} · {{size}} producten elk",
      client_filter_note: "Grootte, oriëntatie en status worden in de browser berekend en filteren alleen het hier geladen blok, niet de hele catalogus. Gebruik Volgende om verder te zoeken.",
      meta_loading: "Nog {{n}} afbeeldingen worden gelezen — de telling stabiliseert nog",
      meta_unresolved: "{{n}} uitgesloten: afmetingen niet beschikbaar",
      empty_title: "Selecteer een product om te vergelijken",
      slider_hint: "Sleep de greep om te vergelijken",
      recommended: "Aanbevolen",
      size_unknown: "grootte n.v.t.",
      badge_optimized: "Geoptimaliseerd",
      quality_small: "Kleiner bestand",
      quality_best: "Beste kwaliteit",
      output_dims: "Uitvoer: {{dims}} px",
      output_quality: "kwaliteit {{q}} %",
      saved_label: "Bespaard",
      cta_est_saving: "~{{size}} bespaard · geen AI-credits",
      cta_free: "Geen AI-credits gebruikt",
      stat_selected: "Geselecteerd",
      stat_n_images: "{{n}} afbeeldingen",
      stat_current: "Huidige grootte",
      stat_partial: "{{k}} van {{n}} bekend",
      stat_total: "totaal",
      stat_after: "Na",
      stat_projected: "geschat",
      stat_no_baseline: "na de eerste run",
      stat_saving: "Besparing",
      stat_your_avg: "uw gemiddelde",
      stat_no_data: "nog geen data",
      stat_saved_total: "Tot nu bespaard",
      stat_n_ops: "{{n}} afbeeldingen",
      processing_title: "Afbeeldingen optimaliseren…",
      processing_prep: "Voorbereiden…",
      processing_done: "{{done}} van {{total}} klaar",
      processing_eta: "~{{time}} resterend",
      results_title: "Optimalisatie voltooid",
      results_cancelled: "Run gestopt",
      results_sub: "Bekijk de resultaten en pas ze toe op Shopify",
      results_images: "Afbeeldingen",
      results_saved: "Vrijgemaakte ruimte",
      results_avg: "Gemiddelde",
      results_from_to: "Van → Naar",
      info_vendor: "Leverancier",
      info_images: "Afbeeldingen",
      info_dims: "Afmetingen",
      info_weight: "Gewicht",
      info_seo: "SEO",
      info_status: "Status",
      history_product: "Product",
    },
  },
  pl: {
    score_card: {
      label_not_run: "Niewykonane",
    },
    batch: {
      credits_exhausted_toast: "Kredyty wyczerpane ({{used}}/{{limit}}) — kup więcej lub zmień plan",
      credits_exhausted_title: "Kredyty AI wyczerpane",
      credits_exhausted_desc: "Wykorzystałeś wszystkie {{used}} z {{limit}} miesięcznych kredytów AI. Kup więcej kredytów lub przejdź na wyższy plan, aby kontynuować generowanie treści.",
      credits_buy_cta: "Kup więcej kredytów",
      credits_upgrade_cta: "Zmień plan",
    },
    dashboard: {
      hero_cta_title: "Odkryj problemy SEO swojego sklepu",
      hero_cta_desc: "Uruchom pełną analizę: zsynchronizuj produkty, oblicz wynik SEO i uzyskaj Audyt 360° w kilka minut.",
      hero_cta_btn: "Rozpocznij bezpłatną analizę",
      advisor_title: "AI Store Advisor",
      advisor_badge: "Wygenerowano automatycznie",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Uszeregowane wg możliwego do odzyskania wyniku",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Gdzie Twój czas przynosi najwięcej",
      opportunity_tooltip: "Wpływ jest względny wobec największej szansy w Twoim sklepie, obliczony z formuły wyniku — to nie obietnica pozycji w wyszukiwarce.",
      opp_impact: "Wpływ",
      opp_open: "Otwórz",
      opp_issues: "{{n}} problemów",
      opp_no_count: "w całej witrynie",
      opp_meta_description: "Meta Description",
      opp_product_description: "Opis produktu",
      opp_alt_text: "Tekst ALT",
      opp_performance: "Optymalizacja szybkości",
      opp_structured_data: "Dane strukturalne",
      opp_technical_seo: "Techniczne SEO",
      opp_ux: "Doświadczenie użytkownika",
      roi_very_high: "Bardzo wysoki ROI",
      roi_high: "Wysoki ROI",
      roi_medium: "Średni ROI",
      roi_low: "Niski ROI",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} to główny czynnik ograniczający wynik Twojego sklepu ({{value}}/100).",
      insight_top_opportunity: "{{label}} to obecnie działanie o największym wpływie.",
      insight_strongest: "{{dim}} jest już w doskonałym stanie ({{value}}/100) — nie trzeba tu nic robić.",
      insight_alt: "Dostępność obrazów można poprawić: {{n}} obrazów wciąż nie ma tekstu ALT.",
      insight_top_three: "Zamknięcie trzech największych szans jest warte około +{{n}} punktów wyniku ogólnego.",
      advisor_strong: "Twój sklep jest technicznie w dobrej kondycji",
      advisor_weak_open: "Twój sklep ma pole do poprawy na wielu obszarach",
      advisor_blocked: "ale wynik Katalogu ({{score}}/100) jest ograniczany przez",
      advisor_no_desc: "produktów bez opisu",
      advisor_no_meta: "produktów bez meta description",
      advisor_no_alt: "obrazów bez tekstu ALT",
      advisor_advice: "Zaczynając od tego zyskasz co najmniej +{{gain}} punktów Katalogu",
      advisor_clean: "Brak luk strukturalnych w katalogu — tak trzymaj.",
      advisor_and: "i",
      advisor_cta: "Zacznij od tego działania",
      advisor_great_title: "Świetna robota — Twój sklep jest zoptymalizowany",
      advisor_great_sub: "Nie ma już luk strukturalnych. Uruchom audyt ponownie po kolejnych zmianach, aby tak zostało.",
      section_quickwins: "Quick Wins polecane przez AI",
      hint_quickwins: "Uszeregowane wg wpływu na wynik",
      priority_high: "wysoki",
      priority_medium: "średni",
      priority_low: "niski",
      gain_tooltip: "Minimalny zysk w wyniku Katalogu wg formuły. Generowanie treści zwykle podnosi go jeszcze bardziej.",
      eta_tooltip: "Oszacowane na podstawie zaobserwowanej wydajności",
      eta_seconds: "{{n}}s",
      eta_minutes: "{{n}} min",
      n_credits: "{{n}} kredytów",
      no_credits: "bez kredytów",
      fix_btn: "Napraw",
      dim_technical: "Techniczne SEO",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Wydajność",
      dim_catalog: "Katalog",
      perf_load: "Czas ładowania",
      perf_weight: "Waga strony",
      perf_lazy: "Obrazy lazy-load",
      perf_all: "wszystkie",
      perf_target: "cel",
      credits_unlimited: "Bez limitu",
      credits_left: "pozostało {{n}} kredytów",
      credits_exhausted: "Miesięczne kredyty wyczerpane",
      credits_buy: "Zdobądź więcej kredytów",
      forecast: "~{{n}}/miesiąc w obecnym tempie",
      forecast_tooltip: "Ekstrapolowane ze zużycia od instalacji",
      activity_empty: "Brak aktywności",
      activity_fields: "pól",
      time_now: "przed chwilą",
      time_min: "{{n}} min temu",
      time_hour: "{{n}} godz. temu",
      time_day: "{{n}} dni temu",
      qw_missing_description_title: "{{n}} produktów bez opisu",
      qw_missing_description_desc: "Puste opisy szkodzą SEO. Wygeneruj je z AI.",
      qw_missing_meta_description_title: "{{n}} produktów bez meta description",
      qw_missing_meta_description_desc: "Wygeneruj meta description z AI, aby poprawić klikalność w wynikach.",
      qw_missing_alt_text_title: "{{n}} obrazów bez tekstu ALT",
      qw_missing_alt_text_desc: "Dodaj tekst ALT do zdjęć produktów — dla SEO i dostępności.",
      qw_missing_product_image_title: "{{n}} produktów bez zdjęcia",
      qw_missing_product_image_desc: "Produkty bez zdjęcia konwertują znacznie gorzej. Dodaj je.",
    },
    onboarding: {
      welcome_title: "Witamy w AI Optimizer 🎉",
      done_title: "Analiza zakończona ✅",
      running_title: "Analiza w toku…",
      store_connected: "Sklep {{domain}} połączony pomyślnie.",
      skip_label: "Pomiń",
      intro_text: "Pozwól nam automatycznie przeanalizować Twój sklep, aby pokazać prawdziwe problemy SEO i sposoby ich rozwiązania.",
      step1_title: "Synchronizacja produktów",
      step1_sub: "Importuj katalog ze Shopify",
      step2_title: "Analiza SEO produktów",
      step2_sub: "Wynik SEO dla każdego produktu",
      step3_title: "Audyt witryny 360°",
      step3_sub: "Techniczne SEO, UX, Trust, Performance",
      time_estimate: "Szacowany czas: 1–3 minuty w zależności od rozmiaru katalogu.",
      start_btn: "Rozpocznij bezpłatną analizę",
      skip_btn: "Pomiń na razie — przejdź do panelu",
      error_fallback: "Wystąpił błąd. Spróbuj ponownie z panelu.",
      retry_btn: "Spróbuj ponownie",
      products_label: "produktów",
      scanning: "Skanowanie…",
      no_close: "Nie zamykaj tego okna podczas analizy",
      store_score_label: "Store Score",
      done_text: "Panel jest teraz wypełniony prawdziwymi danymi. Odkryj problemy i zacznij optymalizować.",
      see_results_btn: "Zobacz wyniki",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "Edytor AI",
      current_version: "Obecna wersja",
      ai_suggestion: "Sugestia AI",
      generate_ai_btn: "Generuj z AI",
      regenerate_btn: "Wygeneruj ponownie",
      generate_field_title: "Wygeneruj to pole z AI",
      apply_to_shopify: "Zastosuj w Shopify",
      diff_legend: "Podświetlone = dodane lub zmienione przez AI",
      unsaved_suggestions: "{{n}} sugestii AI",
      field_limit: "zalecane maks. {{n}} znaków",
      last_published: "Ostatnia publikacja",
      empty_title: "Wybierz element, aby zacząć",
      stat_seo: "Wynik SEO",
      stat_readability: "Czytelność",
      stat_words: "Słowa",
      stat_keywords: "Słowa kluczowe",
      stat_fields: "Pola",
      stat_not_analyzed: "nieprzeanalizowane",
      stat_wps: "{{n}} słów/zdanie",
      stat_no_text: "brak tekstu",
      stat_in_description: "w opisie",
      stat_found: "znaleziono",
      stat_completed: "uzupełnione",
      read_easy: "Łatwa",
      read_medium: "Średnia",
      read_complex: "Złożona",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Podgląd tłumaczenia",
      preview_hint: "To jest treść źródłowa, która zostanie przetłumaczona",
      from: "Z",
      to: "Na",
      current: "Obecnie",
      original: "Oryginał",
      ai_translation: "Tłumaczenie AI",
      ai_working: "AI tłumaczy…",
      preparing: "Przygotowywanie…",
      progress_line: "{{done}} z {{total}} elementów · po {{fields}} pól",
      translate_n: "Przetłumacz {{n}}",
      translate_page: "Przetłumacz {{n}} na {{lang}}",
      goto_page: "wybrano {{n}} — przejdź do ich strony",
      select_all_fields: "Zaznacz wszystko",
      deselect_fields: "Odznacz",
      badge_translated: "Przetłumaczone",
      not_selected: "niezaznaczone",
      empty_field: "Puste — zostanie pominięte",
      loading_detail: "Wczytywanie treści…",
      empty_title: "Wybierz element do podglądu",
      n_items: "{{n}} element(ów)",
      n_fields: "{{n}} pól",
      stat_selected: "Wybrane",
      stat_target: "Język docelowy",
      stat_from: "z {{lang}}",
      stat_fields: "Pola",
      stat_per_item: "na element",
      stat_credits: "Szac. kredyty",
      stat_credits_sub: "1 na element · cache za darmo",
      stat_credits_na: "nierozliczane",
      stat_time: "Szac. czas",
      stat_time_sub: "przybliżony",
      note_fields: "Pola SEO tłumaczone osobno",
      note_cache: "W cache — powtórzenia są darmowe",
      note_review: "Sprawdź przed publikacją",
    },
    images: {
      studio_pill: "Studio porównania",
      result_title: "Wynik optymalizacji",
      result_sub: "Zastosuj w Shopify, aby zachować oszczędność",
      result_grew_title: "Ten obraz się powiększył",
      result_grew_sub: "Źródło jest mniejsze niż rozmiar docelowy, więc skalowanie go powiększyło",
      result_before: "przed",
      result_after: "po",
      result_added: "Dodano",
      result_extra: "dodatkowa waga",
      result_freed: "zwolniono",
      result_output: "Wyjście",
      result_no_compress: "bez kompresji",
      results_processed: "przetworzono",
      results_freed: "zwolniono",
      results_per_image: "na obraz",
      results_was: "było {{size}}",
      slider_fullscreen: "otwórz pełny ekran",
      info_pixels: "piksele",
      info_original: "oryginał",
      info_out_of: "na 100",
      info_awaiting_apply: "czeka na zastosowanie",
      info_state: "optymalizacja",
      status_todo: "Do optymalizacji",
      stat_not_scored: "nieocenione",
      cta_n_images: "{{n}} obrazów",
      cta_saving: "~{{size}} zaoszczędzone",
      matches_in_block: "{{matches}} pasujących · przeskanowano {{scanned}} z {{total}}",
      block_info: "Blok {{page}} z {{total}} · po {{size}} produktów",
      client_filter_note: "Waga, orientacja i status są liczone w przeglądarce: filtrują wczytany tu blok, nie cały katalog. Użyj Dalej, aby skanować dalej.",
      meta_loading: "Wczytywanie kolejnych {{n}} obrazów — licznik się jeszcze ustala",
      meta_unresolved: "{{n}} wykluczonych: brak wymiarów",
      empty_title: "Wybierz produkt do porównania",
      slider_hint: "Przeciągnij uchwyt, aby porównać",
      recommended: "Zalecane",
      size_unknown: "waga n/d",
      badge_optimized: "Zoptymalizowany",
      quality_small: "Mniejszy plik",
      quality_best: "Najlepsza jakość",
      output_dims: "Wyjście: {{dims}} px",
      output_quality: "jakość {{q}} %",
      saved_label: "Zaoszczędzone",
      cta_est_saving: "~{{size}} zaoszczędzone · bez kredytów AI",
      cta_free: "Nie zużywa kredytów AI",
      stat_selected: "Wybrane",
      stat_n_images: "{{n}} obrazów",
      stat_current: "Obecna waga",
      stat_partial: "znane {{k}} z {{n}}",
      stat_total: "łącznie",
      stat_after: "Po",
      stat_projected: "szacowane",
      stat_no_baseline: "po pierwszym uruchomieniu",
      stat_saving: "Oszczędność",
      stat_your_avg: "Twoja średnia",
      stat_no_data: "brak danych",
      stat_saved_total: "Zaoszczędzono dotąd",
      stat_n_ops: "{{n}} obrazów",
      processing_title: "Optymalizacja obrazów…",
      processing_prep: "Przygotowywanie…",
      processing_done: "ukończono {{done}} z {{total}}",
      processing_eta: "pozostało ~{{time}}",
      results_title: "Optymalizacja zakończona",
      results_cancelled: "Przerwano",
      results_sub: "Sprawdź wyniki, potem zastosuj w Shopify",
      results_images: "Obrazy",
      results_saved: "Zwolnione miejsce",
      results_avg: "Średnia",
      results_from_to: "Z → Na",
      info_vendor: "Dostawca",
      info_images: "Obrazy",
      info_dims: "Wymiary",
      info_weight: "Waga",
      info_seo: "SEO",
      info_status: "Status",
      history_product: "Produkt",
    },
  },
  ar: {
    score_card: {
      label_not_run: "لم يُنفَّذ",
    },
    batch: {
      credits_exhausted_toast: "نفدت الاعتمادات ({{used}}/{{limit}}) — اشترِ المزيد أو قم بالترقية",
      credits_exhausted_title: "نفدت اعتمادات الذكاء الاصطناعي",
      credits_exhausted_desc: "لقد استخدمت جميع {{used}} من {{limit}} اعتماداً شهرياً للذكاء الاصطناعي. اشترِ المزيد من الاعتمادات أو قم بالترقية للاستمرار في إنشاء المحتوى.",
      credits_buy_cta: "شراء المزيد من الاعتمادات",
      credits_upgrade_cta: "ترقية الخطة",
    },
    dashboard: {
      hero_cta_title: "اكتشف مشكلات SEO في متجرك",
      hero_cta_desc: "ابدأ التحليل الكامل: زامن المنتجات واحسب نقاط SEO واحصل على تدقيق 360° في دقائق.",
      hero_cta_btn: "ابدأ التحليل المجاني",
      advisor_title: "AI Store Advisor",
      advisor_badge: "مُولَّد تلقائياً",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "مرتَّب حسب النقاط القابلة للاسترجاع",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "حيث يثمر وقتك أكثر",
      opportunity_tooltip: "التأثير نسبي مقارنة بأكبر فرصة في متجرك، محسوب من معادلة النقاط — وليس وعداً مطلقاً بترتيب البحث.",
      opp_impact: "التأثير",
      opp_open: "فتح",
      opp_issues: "{{n}} مشكلة",
      opp_no_count: "على مستوى الموقع",
      opp_meta_description: "وصف الميتا",
      opp_product_description: "وصف المنتج",
      opp_alt_text: "نص ALT",
      opp_performance: "تحسين السرعة",
      opp_structured_data: "البيانات المنظمة",
      opp_technical_seo: "SEO التقني",
      opp_ux: "تجربة المستخدم",
      roi_very_high: "عائد مرتفع جداً",
      roi_high: "عائد مرتفع",
      roi_medium: "عائد متوسط",
      roi_low: "عائد منخفض",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} هو العامل الرئيسي الذي يحدّ من نقاط متجرك ({{value}}/100).",
      insight_top_opportunity: "{{label}} هو الإجراء الأكبر تأثيراً المتاح الآن.",
      insight_strongest: "{{dim}} في حالة ممتازة بالفعل ({{value}}/100) — لا حاجة للعمل هنا.",
      insight_alt: "يمكن تحسين إتاحة الصور: {{n}} صورة ما زالت بلا نص ALT.",
      insight_top_three: "معالجة أهم ثلاث فرص تساوي نحو +{{n}} نقطة من النتيجة الإجمالية.",
      advisor_strong: "متجرك في حالة تقنية جيدة",
      advisor_weak_open: "متجرك لديه مجال للتحسّن على عدة جوانب",
      advisor_blocked: "لكن نقاط الكتالوج ({{score}}/100) مقيَّدة بسبب",
      advisor_no_desc: "منتجات بلا وصف",
      advisor_no_meta: "منتجات بلا وصف ميتا",
      advisor_no_alt: "صور بلا نص ALT",
      advisor_advice: "البدء من هنا يساوي على الأقل +{{gain}} نقطة كتالوج",
      advisor_clean: "لم تعد هناك ثغرات هيكلية في الكتالوج — واصل هكذا.",
      advisor_and: "و",
      advisor_cta: "ابدأ بهذا الإجراء",
      advisor_great_title: "عمل رائع — متجرك مُحسَّن",
      advisor_great_sub: "لم تعد هناك ثغرات هيكلية. أعد تشغيل التدقيق بعد تغييراتك التالية للحفاظ على ذلك.",
      section_quickwins: "مكاسب سريعة يوصي بها الذكاء الاصطناعي",
      hint_quickwins: "مرتَّبة حسب التأثير على النتيجة",
      priority_high: "عالية",
      priority_medium: "متوسطة",
      priority_low: "منخفضة",
      gain_tooltip: "الحد الأدنى للمكسب في نقاط الكتالوج وفق المعادلة. توليد المحتوى يرفعها عادةً أكثر.",
      eta_tooltip: "مُقدَّر من الأداء المُلاحَظ",
      eta_seconds: "{{n}} ث",
      eta_minutes: "{{n}} د",
      n_credits: "{{n}} اعتماد",
      no_credits: "بدون اعتمادات",
      fix_btn: "إصلاح",
      dim_technical: "SEO التقني",
      dim_ux: "UX",
      dim_trust: "الثقة",
      dim_performance: "الأداء",
      dim_catalog: "الكتالوج",
      perf_load: "زمن التحميل",
      perf_weight: "وزن الصفحة",
      perf_lazy: "صور التحميل الكسول",
      perf_all: "الكل",
      perf_target: "الهدف",
      credits_unlimited: "غير محدود",
      credits_left: "تبقّى {{n}} اعتماد",
      credits_exhausted: "نفدت الاعتمادات الشهرية",
      credits_buy: "احصل على اعتمادات إضافية",
      forecast: "~{{n}}/شهر بالوتيرة الحالية",
      forecast_tooltip: "مُستقرأ من استهلاكك منذ التثبيت",
      activity_empty: "لا يوجد نشاط بعد",
      activity_fields: "حقول",
      time_now: "الآن",
      time_min: "قبل {{n}} د",
      time_hour: "قبل {{n}} س",
      time_day: "قبل {{n}} ي",
      qw_missing_description_title: "{{n}} منتج بلا وصف",
      qw_missing_description_desc: "الأوصاف الفارغة تضر بالـ SEO. ولّدها بالذكاء الاصطناعي.",
      qw_missing_meta_description_title: "{{n}} منتج بلا وصف ميتا",
      qw_missing_meta_description_desc: "ولّد أوصاف ميتا بالذكاء الاصطناعي لتحسين نسبة النقر في نتائج البحث.",
      qw_missing_alt_text_title: "{{n}} صورة بلا نص ALT",
      qw_missing_alt_text_desc: "أضف نص ALT لصور المنتجات لتحسين الـ SEO وإتاحة الوصول.",
      qw_missing_product_image_title: "{{n}} منتج بلا صورة",
      qw_missing_product_image_desc: "المنتجات بلا صور تحقق تحويلاً أقل بكثير. أضف صورة.",
    },
    onboarding: {
      welcome_title: "مرحباً في AI Optimizer 🎉",
      done_title: "اكتمل التحليل ✅",
      running_title: "جارٍ التحليل…",
      store_connected: "تم توصيل المتجر {{domain}} بنجاح.",
      skip_label: "تخطي",
      intro_text: "دعنا نحلل متجرك تلقائياً لنوضح لك مشكلات SEO الحقيقية وكيفية حلها.",
      step1_title: "مزامنة المنتجات",
      step1_sub: "استيراد الكتالوج من Shopify",
      step2_title: "تحليل SEO للمنتجات",
      step2_sub: "نقاط SEO لكل منتج",
      step3_title: "تدقيق الموقع 360°",
      step3_sub: "SEO التقني، UX، الثقة، الأداء",
      time_estimate: "الوقت المقدر: 1–3 دقائق حسب حجم الكتالوج.",
      start_btn: "ابدأ التحليل المجاني",
      skip_btn: "تخطي الآن — الاستمرار من لوحة التحكم",
      error_fallback: "حدث خطأ. يرجى المحاولة مرة أخرى من لوحة التحكم.",
      retry_btn: "إعادة المحاولة",
      products_label: "منتجات",
      scanning: "جارٍ الفحص…",
      no_close: "لا تغلق هذه النافذة أثناء التحليل",
      store_score_label: "Store Score",
      done_text: "لوحة التحكم مليئة الآن ببيانات حقيقية. اكتشف المشكلات وابدأ التحسين.",
      see_results_btn: "عرض النتائج",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "محرر الذكاء الاصطناعي",
      current_version: "النسخة الحالية",
      ai_suggestion: "اقتراح الذكاء الاصطناعي",
      generate_ai_btn: "توليد بالذكاء الاصطناعي",
      regenerate_btn: "إعادة التوليد",
      generate_field_title: "توليد هذا الحقل بالذكاء الاصطناعي",
      apply_to_shopify: "تطبيق على Shopify",
      diff_legend: "المُظلَّل = أضافه أو غيّره الذكاء الاصطناعي",
      unsaved_suggestions: "{{n}} اقتراح",
      field_limit: "الحد الموصى به {{n}} حرفاً",
      last_published: "آخر نشر",
      empty_title: "اختر عنصراً للبدء",
      stat_seo: "نقاط SEO",
      stat_readability: "سهولة القراءة",
      stat_words: "الكلمات",
      stat_keywords: "الكلمات المفتاحية",
      stat_fields: "الحقول",
      stat_not_analyzed: "لم يُحلَّل",
      stat_wps: "{{n}} كلمة/جملة",
      stat_no_text: "لا يوجد نص",
      stat_in_description: "في الوصف",
      stat_found: "موجودة",
      stat_completed: "مكتملة",
      read_easy: "سهلة",
      read_medium: "متوسطة",
      read_complex: "معقدة",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "معاينة الترجمة",
      preview_hint: "هذا هو المحتوى المصدر الذي ستتم ترجمته",
      from: "من",
      to: "إلى",
      current: "الحالي",
      original: "الأصل",
      ai_translation: "ترجمة الذكاء الاصطناعي",
      ai_working: "الذكاء الاصطناعي يترجم…",
      preparing: "جارٍ التحضير…",
      progress_line: "{{done}} من {{total}} عنصر · {{fields}} حقول لكل منها",
      translate_n: "ترجم {{n}}",
      translate_page: "ترجم {{n}} إلى {{lang}}",
      goto_page: "{{n}} محدد — انتقل إلى صفحتها",
      select_all_fields: "تحديد الكل",
      deselect_fields: "إلغاء التحديد",
      badge_translated: "مُترجَم",
      not_selected: "غير محدد",
      empty_field: "فارغ — سيتم تخطيه",
      loading_detail: "جارٍ تحميل المحتوى…",
      empty_title: "اختر عنصراً للمعاينة",
      n_items: "{{n}} عنصر",
      n_fields: "{{n}} حقول",
      stat_selected: "المحددة",
      stat_target: "لغة الهدف",
      stat_from: "من {{lang}}",
      stat_fields: "الحقول",
      stat_per_item: "لكل عنصر",
      stat_credits: "الاعتمادات المقدرة",
      stat_credits_sub: "1 لكل عنصر · الذاكرة المؤقتة مجانية",
      stat_credits_na: "غير محتسب",
      stat_time: "الوقت المقدر",
      stat_time_sub: "تقريبي",
      note_fields: "حقول SEO تُترجم بشكل منفصل",
      note_cache: "مخزَّن مؤقتاً — التكرار مجاني",
      note_review: "راجع قبل النشر",
    },
    images: {
      studio_pill: "استوديو المقارنة",
      result_title: "نتيجة التحسين",
      result_sub: "طبّقها على Shopify للحفاظ على التوفير",
      result_grew_title: "أصبحت هذه الصورة أكبر",
      result_grew_sub: "المصدر أصغر من الحجم المستهدف، لذا أدى التحجيم إلى تكبيرها",
      result_before: "قبل",
      result_after: "بعد",
      result_added: "أُضيف",
      result_extra: "وزن إضافي",
      result_freed: "تم تحريره",
      result_output: "الإخراج",
      result_no_compress: "بدون ضغط",
      results_processed: "تمت معالجتها",
      results_freed: "تم تحريره",
      results_per_image: "لكل صورة",
      results_was: "كان {{size}}",
      slider_fullscreen: "فتح ملء الشاشة",
      info_pixels: "بكسل",
      info_original: "الأصل",
      info_out_of: "من 100",
      info_awaiting_apply: "في انتظار التطبيق",
      info_state: "التحسين",
      status_todo: "بحاجة إلى تحسين",
      stat_not_scored: "غير مقيَّم",
      cta_n_images: "{{n}} صورة",
      cta_saving: "~{{size}} موفَّرة",
      matches_in_block: "{{matches}} مطابقة · فُحصت {{scanned}} من {{total}}",
      block_info: "الكتلة {{page}} من {{total}} · {{size}} منتج لكل كتلة",
      client_filter_note: "يُحسب الحجم والاتجاه والحالة في المتصفح، لذا تُصفّى الكتلة المحمَّلة هنا فقط وليس الكتالوج كاملاً. استخدم التالي للمتابعة.",
      meta_loading: "تتم قراءة {{n}} صورة إضافية — العدد ما زال يستقر",
      meta_unresolved: "{{n}} مستبعدة: الأبعاد غير متاحة",
      empty_title: "اختر منتجاً للمقارنة",
      slider_hint: "اسحب المقبض للمقارنة",
      recommended: "موصى به",
      size_unknown: "الحجم غير متاح",
      badge_optimized: "مُحسَّنة",
      quality_small: "ملف أصغر",
      quality_best: "أفضل جودة",
      output_dims: "الإخراج: {{dims}} بكسل",
      output_quality: "الجودة {{q}}%",
      saved_label: "موفَّرة",
      cta_est_saving: "~{{size}} موفَّرة · بدون اعتمادات AI",
      cta_free: "لا تُستخدم اعتمادات AI",
      stat_selected: "المحددة",
      stat_n_images: "{{n}} صورة",
      stat_current: "الحجم الحالي",
      stat_partial: "{{k}} من {{n}} معروفة",
      stat_total: "الإجمالي",
      stat_after: "بعد",
      stat_projected: "مُقدَّر",
      stat_no_baseline: "بعد أول تشغيل",
      stat_saving: "التوفير",
      stat_your_avg: "متوسطك",
      stat_no_data: "لا بيانات",
      stat_saved_total: "الموفَّر حتى الآن",
      stat_n_ops: "{{n}} صورة",
      processing_title: "جارٍ تحسين الصور…",
      processing_prep: "جارٍ التحضير…",
      processing_done: "اكتملت {{done}} من {{total}}",
      processing_eta: "تبقّى ~{{time}}",
      results_title: "اكتمل التحسين",
      results_cancelled: "تم إيقاف التشغيل",
      results_sub: "راجع النتائج ثم طبّقها على Shopify",
      results_images: "الصور",
      results_saved: "المساحة المحرَّرة",
      results_avg: "المتوسط",
      results_from_to: "من ← إلى",
      info_vendor: "المورّد",
      info_images: "الصور",
      info_dims: "الأبعاد",
      info_weight: "الحجم",
      info_seo: "SEO",
      info_status: "الحالة",
      history_product: "المنتج",
    },
  },
  tr: {
    score_card: {
      label_not_run: "Çalıştırılmadı",
    },
    // Turkish has no block in translations.js, so settings.* falls back to
    // English key by key. These are the billing terms a merchant must be
    // able to read before subscribing, so they are worth translating here even
    // while the rest of the Settings page is still English.
    settings: {
      piano: {
        plan_overage: "Ek AI kredileri: kredi başına {{price}}",
        plan_no_overage: "Ek AI kredisi ücreti yok",
        plan_trial_line: "{{n}} günlük ücretsiz deneme",
        plans_note: "Ücretli planlar {{n}} günlük ücretsiz deneme içerir. Aktivasyon ücreti yok. Ödemeler Shopify Billing tarafından yönetilir.",
        // The date shown is when the app's credit allowance resets, which is
        // not the same thing as when Shopify renews the subscription.
        next_credit_reset: "Sonraki kredi sıfırlama",
        toast_store_unavailable: "Mağaza henüz bağlanmadı. Uygulamayı Shopify Admin'de yeniden yükleyip tekrar deneyin.",
      },
    },
    batch: {
      credits_exhausted_toast: "Krediler tükendi ({{used}}/{{limit}}) — daha fazla satın al veya planı yükselt",
      credits_exhausted_title: "AI kredileri tükendi",
      credits_exhausted_desc: "{{limit}} aylık AI kredinizin tamamı olan {{used}} tanesini kullandınız. İçerik üretmeye devam etmek için daha fazla kredi satın alın veya planınızı yükseltin.",
      credits_buy_cta: "Daha Fazla Kredi Satın Al",
      credits_upgrade_cta: "Planı Yükselt",
    },
    dashboard: {
      hero_cta_title: "Mağazanızın SEO sorunlarını keşfedin",
      hero_cta_desc: "Tam analizi başlatın: ürünleri senkronize edin, SEO puanını hesaplayın ve birkaç dakikada 360° Denetimi alın.",
      hero_cta_btn: "Ücretsiz Analizi Başlat",
      advisor_title: "AI Store Advisor",
      advisor_badge: "Otomatik oluşturuldu",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "Geri kazanılabilir puana göre sıralı",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "Zamanınızın en çok değer kazandığı yer",
      opportunity_tooltip: "Etki, mağazanızdaki en büyük fırsata göre görecelidir ve puan formülünden hesaplanır — mutlak bir sıralama vaadi değildir.",
      opp_impact: "Etki",
      opp_open: "Aç",
      opp_issues: "{{n}} sorun",
      opp_no_count: "site genelinde",
      opp_meta_description: "Meta Description",
      opp_product_description: "Ürün açıklaması",
      opp_alt_text: "ALT metni",
      opp_performance: "Hız optimizasyonu",
      opp_structured_data: "Yapılandırılmış veri",
      opp_technical_seo: "Teknik SEO",
      opp_ux: "Kullanıcı deneyimi",
      roi_very_high: "Çok yüksek ROI",
      roi_high: "Yüksek ROI",
      roi_medium: "Orta ROI",
      roi_low: "Düşük ROI",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}}, mağaza puanınızı sınırlayan başlıca etken ({{value}}/100).",
      insight_top_opportunity: "{{label}} şu anda mevcut en yüksek etkili müdahale.",
      insight_strongest: "{{dim}} zaten mükemmel durumda ({{value}}/100) — burada yapılacak bir şey yok.",
      insight_alt: "Görsel erişilebilirliği iyileştirilebilir: {{n}} görselin hâlâ ALT metni yok.",
      insight_top_three: "İlk üç fırsatı kapatmak yaklaşık +{{n}} puan genel skor değerinde.",
      advisor_strong: "Mağazanız teknik olarak iyi durumda",
      advisor_weak_open: "Mağazanızın birçok alanda gelişme alanı var",
      advisor_blocked: "ancak Katalog puanı ({{score}}/100) şunlar tarafından sınırlanıyor",
      advisor_no_desc: "açıklaması olmayan ürün",
      advisor_no_meta: "meta description'ı olmayan ürün",
      advisor_no_alt: "ALT metni olmayan görsel",
      advisor_advice: "Buradan başlamak en az +{{gain}} Katalog puanı değerinde",
      advisor_clean: "Katalogda yapısal boşluk kalmadı — böyle devam.",
      advisor_and: "ve",
      advisor_cta: "Bu işlemle başla",
      advisor_great_title: "Harika iş — mağazanız optimize edilmiş",
      advisor_great_sub: "Yapısal boşluk kalmadı. Bir sonraki değişikliklerinizden sonra denetimi tekrar çalıştırın.",
      section_quickwins: "AI'nin önerdiği Quick Wins",
      hint_quickwins: "Puan etkisine göre sıralı",
      priority_high: "yüksek",
      priority_medium: "orta",
      priority_low: "düşük",
      gain_tooltip: "Formüle göre Katalog puanındaki asgari kazanç. İçerik üretmek genelde daha da yükseltir.",
      eta_tooltip: "Gözlemlenen hızdan tahmin edildi",
      eta_seconds: "{{n}}sn",
      eta_minutes: "{{n}} dk",
      n_credits: "{{n}} kredi",
      no_credits: "kredi yok",
      fix_btn: "Düzelt",
      dim_technical: "Teknik SEO",
      dim_ux: "UX",
      dim_trust: "Trust",
      dim_performance: "Performans",
      dim_catalog: "Katalog",
      perf_load: "Yüklenme süresi",
      perf_weight: "Sayfa ağırlığı",
      perf_lazy: "Lazy yüklenen görseller",
      perf_all: "tümü",
      perf_target: "hedef",
      credits_unlimited: "Sınırsız",
      credits_left: "{{n}} kredi kaldı",
      credits_exhausted: "Aylık krediler tükendi",
      credits_buy: "Daha fazla kredi al",
      forecast: "mevcut hızda ~{{n}}/ay",
      forecast_tooltip: "Kurulumdan bu yana kullanımınızdan tahmin edildi",
      activity_empty: "Henüz etkinlik yok",
      activity_fields: "alan",
      time_now: "az önce",
      time_min: "{{n}} dk önce",
      time_hour: "{{n}} sa önce",
      time_day: "{{n}} g önce",
      qw_missing_description_title: "Açıklaması olmayan {{n}} ürün",
      qw_missing_description_desc: "Boş açıklamalar SEO'ya zarar verir. AI ile üretin.",
      qw_missing_meta_description_title: "Meta description'ı olmayan {{n}} ürün",
      qw_missing_meta_description_desc: "Arama tıklama oranını artırmak için AI ile SEO meta description üretin.",
      qw_missing_alt_text_title: "ALT metni olmayan {{n}} görsel",
      qw_missing_alt_text_desc: "SEO ve erişilebilirlik için ürün görsellerine ALT metni ekleyin.",
      qw_missing_product_image_title: "Görseli olmayan {{n}} ürün",
      qw_missing_product_image_desc: "Görseli olmayan ürünler çok daha az dönüşür. Bir görsel ekleyin.",
    },
    onboarding: {
      welcome_title: "AI Optimizer'a Hoş Geldiniz 🎉",
      done_title: "Analiz tamamlandı ✅",
      running_title: "Analiz devam ediyor…",
      store_connected: "Mağaza {{domain}} başarıyla bağlandı.",
      skip_label: "Atla",
      intro_text: "Gerçek SEO sorunlarını ve çözüm yollarını göstermek için mağazanızı otomatik olarak analiz etmemize izin verin.",
      step1_title: "Ürün senkronizasyonu",
      step1_sub: "Shopify'dan kataloğu içe aktarın",
      step2_title: "Ürün SEO analizi",
      step2_sub: "Her ürün için SEO puanı",
      step3_title: "Site Denetimi 360°",
      step3_sub: "Teknik SEO, UX, Güven, Performans",
      time_estimate: "Tahmini süre: Katalog boyutuna göre 1–3 dakika.",
      start_btn: "Ücretsiz Analizi Başlat",
      skip_btn: "Şimdi atla — panelden devam et",
      error_fallback: "Bir hata oluştu. Lütfen panelden tekrar deneyin.",
      retry_btn: "Tekrar dene",
      products_label: "ürünler",
      scanning: "Taranıyor…",
      no_close: "Analiz sırasında bu pencereyi kapatmayın",
      store_score_label: "Store Score",
      done_text: "Panel artık gerçek verilerle dolu. Sorunları keşfedin ve optimize etmeye başlayın.",
      see_results_btn: "Sonuçları Gör",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "AI Editörü",
      current_version: "Mevcut sürüm",
      ai_suggestion: "AI önerisi",
      generate_ai_btn: "AI ile üret",
      regenerate_btn: "Yeniden üret",
      generate_field_title: "Bu alanı AI ile üret",
      apply_to_shopify: "Shopify'a uygula",
      diff_legend: "Vurgulanan = AI tarafından eklendi veya değiştirildi",
      unsaved_suggestions: "{{n}} AI önerisi",
      field_limit: "önerilen en fazla {{n}} karakter",
      last_published: "Son yayınlama",
      empty_title: "Başlamak için bir öğe seçin",
      stat_seo: "SEO Puanı",
      stat_readability: "Okunabilirlik",
      stat_words: "Kelime",
      stat_keywords: "Anahtar kelimeler",
      stat_fields: "Alanlar",
      stat_not_analyzed: "analiz edilmedi",
      stat_wps: "cümle başına {{n}} kelime",
      stat_no_text: "metin yok",
      stat_in_description: "açıklamada",
      stat_found: "bulundu",
      stat_completed: "tamamlandı",
      read_easy: "Kolay",
      read_medium: "Orta",
      read_complex: "Karmaşık",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "Çeviri önizlemesi",
      preview_hint: "Çevrilecek kaynak içerik budur",
      from: "Kaynak",
      to: "Hedef",
      current: "Mevcut",
      original: "Orijinal",
      ai_translation: "AI çevirisi",
      ai_working: "AI çeviriyor…",
      preparing: "Hazırlanıyor…",
      progress_line: "{{total}} öğeden {{done}} · her biri {{fields}} alan",
      translate_n: "{{n}} çevir",
      translate_page: "{{n}} öğeyi {{lang}} diline çevir",
      goto_page: "{{n}} seçili — sayfalarına git",
      select_all_fields: "Tümünü seç",
      deselect_fields: "Seçimi kaldır",
      badge_translated: "Çevrildi",
      not_selected: "seçili değil",
      empty_field: "Boş — atlanacak",
      loading_detail: "İçerik yükleniyor…",
      empty_title: "Önizleme için bir öğe seçin",
      n_items: "{{n}} öğe",
      n_fields: "{{n}} alan",
      stat_selected: "Seçili",
      stat_target: "Hedef dil",
      stat_from: "{{lang}} dilinden",
      stat_fields: "Alanlar",
      stat_per_item: "öğe başına",
      stat_credits: "Tahmini kredi",
      stat_credits_sub: "öğe başına 1 · önbellek ücretsiz",
      stat_credits_na: "ücretlendirilmiyor",
      stat_time: "Tahmini süre",
      stat_time_sub: "yaklaşık",
      note_fields: "SEO alanları ayrı ayrı çevrilir",
      note_cache: "Önbellekte — tekrarlar ücretsiz",
      note_review: "Yayınlamadan önce gözden geçirin",
    },
    images: {
      studio_pill: "Karşılaştırma stüdyosu",
      result_title: "Optimizasyon sonucu",
      result_sub: "Tasarrufu korumak için Shopify'a uygulayın",
      result_grew_title: "Bu görsel büyüdü",
      result_grew_sub: "Kaynak, hedef boyuttan küçük olduğu için yeniden boyutlandırma onu büyüttü",
      result_before: "önce",
      result_after: "sonra",
      result_added: "Eklendi",
      result_extra: "fazladan ağırlık",
      result_freed: "boşaltıldı",
      result_output: "Çıktı",
      result_no_compress: "sıkıştırma yok",
      results_processed: "işlendi",
      results_freed: "boşaltıldı",
      results_per_image: "görsel başına",
      results_was: "önceden {{size}}",
      slider_fullscreen: "tam ekran aç",
      info_pixels: "piksel",
      info_original: "orijinal",
      info_out_of: "100 üzerinden",
      info_awaiting_apply: "uygulanmayı bekliyor",
      info_state: "optimizasyon",
      status_todo: "Optimize edilecek",
      stat_not_scored: "puanlanmadı",
      cta_n_images: "{{n}} görsel",
      cta_saving: "~{{size}} tasarruf",
      matches_in_block: "{{matches}} eşleşme · {{total}} içinden {{scanned}} tarandı",
      block_info: "Blok {{page}}/{{total}} · her biri {{size}} ürün",
      client_filter_note: "Boyut, yön ve durum tarayıcıda hesaplanır; bu nedenle tüm katalogu değil yalnızca burada yüklenen bloğu filtreler. Devamı için İleri'yi kullanın.",
      meta_loading: "{{n}} görsel daha okunuyor — sayım henüz oturuyor",
      meta_unresolved: "{{n}} hariç tutuldu: boyutlar mevcut değil",
      empty_title: "Karşılaştırmak için bir ürün seçin",
      slider_hint: "Karşılaştırmak için tutamacı sürükleyin",
      recommended: "Önerilen",
      size_unknown: "boyut yok",
      badge_optimized: "Optimize edildi",
      quality_small: "Daha küçük dosya",
      quality_best: "En iyi kalite",
      output_dims: "Çıktı: {{dims}} px",
      output_quality: "kalite %{{q}}",
      saved_label: "Tasarruf",
      cta_est_saving: "~{{size}} tasarruf · AI kredisi yok",
      cta_free: "AI kredisi kullanılmaz",
      stat_selected: "Seçili",
      stat_n_images: "{{n}} görsel",
      stat_current: "Mevcut boyut",
      stat_partial: "{{n}} içinden {{k}} biliniyor",
      stat_total: "toplam",
      stat_after: "Sonra",
      stat_projected: "tahmini",
      stat_no_baseline: "ilk çalıştırmadan sonra",
      stat_saving: "Tasarruf",
      stat_your_avg: "ortalamanız",
      stat_no_data: "henüz veri yok",
      stat_saved_total: "Şu ana kadar tasarruf",
      stat_n_ops: "{{n}} görsel",
      processing_title: "Görseller optimize ediliyor…",
      processing_prep: "Hazırlanıyor…",
      processing_done: "{{total}} içinden {{done}} tamamlandı",
      processing_eta: "~{{time}} kaldı",
      results_title: "Optimizasyon tamamlandı",
      results_cancelled: "Çalıştırma durduruldu",
      results_sub: "Sonuçları inceleyip Shopify'a uygulayın",
      results_images: "Görseller",
      results_saved: "Kazanılan alan",
      results_avg: "Ortalama",
      results_from_to: "Önce → Sonra",
      info_vendor: "Tedarikçi",
      info_images: "Görseller",
      info_dims: "Boyutlar",
      info_weight: "Ağırlık",
      info_seo: "SEO",
      info_status: "Durum",
      history_product: "Ürün",
    },
  },
  ja: {
    score_card: {
      label_not_run: "未実行",
    },
    batch: {
      credits_exhausted_toast: "クレジット枯渇 ({{used}}/{{limit}}) — クレジットを購入またはプランをアップグレード",
      credits_exhausted_title: "AIクレジットが枯渇しました",
      credits_exhausted_desc: "月間AIクレジット {{limit}} のうち {{used}} をすべて使い切りました。コンテンツの生成を続けるには、クレジットを購入するかプランをアップグレードしてください。",
      credits_buy_cta: "クレジットを購入",
      credits_upgrade_cta: "プランをアップグレード",
    },
    dashboard: {
      hero_cta_title: "ストアのSEO問題を発見する",
      hero_cta_desc: "完全な分析を開始：商品を同期し、SEOスコアを計算して数分で360°監査を取得。",
      hero_cta_btn: "無料分析を開始",
      advisor_title: "AI Store Advisor",
      advisor_badge: "自動生成",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "回復可能なスコア順",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "時間対効果が最も高い領域",
      opportunity_tooltip: "インパクトはストア内で最大の機会を基準とした相対値で、スコア計算式から算出しています。検索順位を保証するものではありません。",
      opp_impact: "インパクト",
      opp_open: "開く",
      opp_issues: "{{n}} 件の課題",
      opp_no_count: "サイト全体",
      opp_meta_description: "メタディスクリプション",
      opp_product_description: "商品説明",
      opp_alt_text: "ALTテキスト",
      opp_performance: "速度の最適化",
      opp_structured_data: "構造化データ",
      opp_technical_seo: "技術SEO",
      opp_ux: "ユーザー体験",
      roi_very_high: "ROI 非常に高い",
      roi_high: "ROI 高い",
      roi_medium: "ROI 中程度",
      roi_low: "ROI 低い",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} がストアスコアを最も制限している要因です（{{value}}/100）。",
      insight_top_opportunity: "現時点で最も効果が大きい施策は {{label}} です。",
      insight_strongest: "{{dim}} はすでに良好な状態です（{{value}}/100）— 対応は不要です。",
      insight_alt: "画像のアクセシビリティを改善できます：{{n}} 枚にALTテキストがありません。",
      insight_top_three: "上位3つの機会を解消すると、総合スコアが約 +{{n}} ポイント向上します。",
      advisor_strong: "ストアは技術的に良好な状態です",
      advisor_weak_open: "ストアには複数の領域で改善の余地があります",
      advisor_blocked: "ただしカタログスコア（{{score}}/100）を制限しているのは",
      advisor_no_desc: "件の説明なし商品",
      advisor_no_meta: "件のメタディスクリプションなし商品",
      advisor_no_alt: "枚のALTテキストなし画像",
      advisor_advice: "ここから着手すると、カタログスコアが少なくとも +{{gain}} ポイント向上します",
      advisor_clean: "カタログに構造的な不足はありません — この調子で。",
      advisor_and: "と",
      advisor_cta: "この施策から始める",
      advisor_great_title: "素晴らしい — ストアは最適化されています",
      advisor_great_sub: "構造的な不足はありません。次の変更後に再度監査を実行して状態を維持してください。",
      section_quickwins: "AIおすすめのクイックウィン",
      hint_quickwins: "スコアへの影響順",
      priority_high: "高",
      priority_medium: "中",
      priority_low: "低",
      gain_tooltip: "計算式に基づくカタログスコアの最小上昇幅です。コンテンツ生成により通常はさらに上がります。",
      eta_tooltip: "実測スループットからの推定",
      eta_seconds: "{{n}}秒",
      eta_minutes: "{{n}}分",
      n_credits: "{{n}} クレジット",
      no_credits: "クレジット不要",
      fix_btn: "修正",
      dim_technical: "技術SEO",
      dim_ux: "UX",
      dim_trust: "信頼性",
      dim_performance: "パフォーマンス",
      dim_catalog: "カタログ",
      perf_load: "読み込み時間",
      perf_weight: "ページ容量",
      perf_lazy: "遅延読み込み画像",
      perf_all: "すべて",
      perf_target: "目標",
      credits_unlimited: "無制限",
      credits_left: "残り {{n}} クレジット",
      credits_exhausted: "月間クレジットを使い切りました",
      credits_buy: "クレジットを追加",
      forecast: "現在のペースで約 {{n}}/月",
      forecast_tooltip: "インストール以降の使用状況からの推計",
      activity_empty: "アクティビティはまだありません",
      activity_fields: "項目",
      time_now: "たった今",
      time_min: "{{n}}分前",
      time_hour: "{{n}}時間前",
      time_day: "{{n}}日前",
      qw_missing_description_title: "説明のない商品 {{n}} 件",
      qw_missing_description_desc: "説明が空だとSEOに不利です。AIで生成しましょう。",
      qw_missing_meta_description_title: "メタディスクリプションのない商品 {{n}} 件",
      qw_missing_meta_description_desc: "AIでSEOメタディスクリプションを生成し、検索でのクリック率を高めます。",
      qw_missing_alt_text_title: "ALTテキストのない画像 {{n}} 枚",
      qw_missing_alt_text_desc: "商品画像にALTテキストを追加し、SEOとアクセシビリティを改善します。",
      qw_missing_product_image_title: "画像のない商品 {{n}} 件",
      qw_missing_product_image_desc: "画像のない商品は転換率が大きく下がります。画像を追加しましょう。",
    },
    onboarding: {
      welcome_title: "AI Optimizerへようこそ 🎉",
      done_title: "分析完了 ✅",
      running_title: "分析中…",
      store_connected: "ストア {{domain}} が正常に接続されました。",
      skip_label: "スキップ",
      intro_text: "ストアを自動分析して、実際のSEO問題とその解決策をご案内します。",
      step1_title: "商品の同期",
      step1_sub: "Shopifyからカタログをインポート",
      step2_title: "商品SEO分析",
      step2_sub: "各商品のSEOスコア",
      step3_title: "サイト監査 360°",
      step3_sub: "技術SEO、UX、信頼性、パフォーマンス",
      time_estimate: "推定時間：カタログサイズにより1〜3分。",
      start_btn: "無料分析を開始",
      skip_btn: "今はスキップ — ダッシュボードから続ける",
      error_fallback: "エラーが発生しました。ダッシュボードから再試行してください。",
      retry_btn: "再試行",
      products_label: "商品",
      scanning: "スキャン中…",
      no_close: "分析中はこのウィンドウを閉じないでください",
      store_score_label: "ストアスコア",
      done_text: "ダッシュボードに実データが表示されました。問題を発見して最適化を始めましょう。",
      see_results_btn: "結果を見る",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "AIエディタ",
      current_version: "現在のバージョン",
      ai_suggestion: "AIの提案",
      generate_ai_btn: "AIで生成",
      regenerate_btn: "再生成",
      generate_field_title: "この項目をAIで生成",
      apply_to_shopify: "Shopifyに適用",
      diff_legend: "ハイライト＝AIが追加・変更した箇所",
      unsaved_suggestions: "AI提案 {{n}} 件",
      field_limit: "推奨最大 {{n}} 文字",
      last_published: "最終公開",
      empty_title: "項目を選択してください",
      stat_seo: "SEOスコア",
      stat_readability: "読みやすさ",
      stat_words: "文字数",
      stat_keywords: "キーワード",
      stat_fields: "項目",
      stat_not_analyzed: "未分析",
      stat_wps: "1文あたり{{n}}語",
      stat_no_text: "テキストなし",
      stat_in_description: "説明文中",
      stat_found: "検出",
      stat_completed: "入力済み",
      read_easy: "やさしい",
      read_medium: "普通",
      read_complex: "難しい",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "翻訳プレビュー",
      preview_hint: "これが翻訳される元のコンテンツです",
      from: "翻訳元",
      to: "翻訳先",
      current: "現在",
      original: "原文",
      ai_translation: "AI翻訳",
      ai_working: "AIが翻訳中…",
      preparing: "準備中…",
      progress_line: "{{total}} 件中 {{done}} 件 · 各 {{fields}} 項目",
      translate_n: "{{n}} 件を翻訳",
      translate_page: "{{n}} 件を{{lang}}に翻訳",
      goto_page: "{{n}} 件選択中 — そのページへ移動",
      select_all_fields: "すべて選択",
      deselect_fields: "選択解除",
      badge_translated: "翻訳済み",
      not_selected: "未選択",
      empty_field: "空 — スキップされます",
      loading_detail: "コンテンツを読み込み中…",
      empty_title: "プレビューする項目を選択",
      n_items: "{{n}} 件",
      n_fields: "{{n}} 項目",
      stat_selected: "選択中",
      stat_target: "翻訳先の言語",
      stat_from: "{{lang}} から",
      stat_fields: "項目",
      stat_per_item: "1件あたり",
      stat_credits: "推定クレジット",
      stat_credits_sub: "1件あたり1 · キャッシュは無料",
      stat_credits_na: "課金なし",
      stat_time: "推定時間",
      stat_time_sub: "おおよそ",
      note_fields: "SEO項目は個別に翻訳されます",
      note_cache: "キャッシュ済み — 再実行は無料",
      note_review: "公開前に確認してください",
    },
    images: {
      studio_pill: "比較スタジオ",
      result_title: "最適化の結果",
      result_sub: "Shopifyに適用して削減を確定します",
      result_grew_title: "この画像は容量が増えました",
      result_grew_sub: "元画像が目標サイズより小さいため、リサイズで拡大されました",
      result_before: "変更前",
      result_after: "変更後",
      result_added: "増加分",
      result_extra: "超過容量",
      result_freed: "削減",
      result_output: "出力",
      result_no_compress: "圧縮なし",
      results_processed: "処理済み",
      results_freed: "削減",
      results_per_image: "1枚あたり",
      results_was: "元 {{size}}",
      slider_fullscreen: "全画面で開く",
      info_pixels: "ピクセル",
      info_original: "オリジナル",
      info_out_of: "100点中",
      info_awaiting_apply: "適用待ち",
      info_state: "最適化",
      status_todo: "要最適化",
      stat_not_scored: "未評価",
      cta_n_images: "{{n}} 枚",
      cta_saving: "約 {{size}} 削減",
      matches_in_block: "{{matches}} 件一致 · {{total}} 件中 {{scanned}} 件を走査",
      block_info: "ブロック {{page}}/{{total}} · 各 {{size}} 件",
      client_filter_note: "容量・向き・状態はブラウザ側で計算するため、カタログ全体ではなくここで読み込んだブロックのみを絞り込みます。さらに探すには「次へ」を使ってください。",
      meta_loading: "さらに {{n}} 枚を読み込み中 — 件数は変動します",
      meta_unresolved: "{{n}} 件除外：サイズ情報が取得できません",
      empty_title: "比較する商品を選択してください",
      slider_hint: "ハンドルをドラッグして比較",
      recommended: "推奨",
      size_unknown: "容量不明",
      badge_optimized: "最適化済み",
      quality_small: "軽いファイル",
      quality_best: "高画質",
      output_dims: "出力：{{dims}} px",
      output_quality: "画質 {{q}}%",
      saved_label: "削減",
      cta_est_saving: "約 {{size}} 削減 · AIクレジット不要",
      cta_free: "AIクレジットは消費しません",
      stat_selected: "選択中",
      stat_n_images: "{{n}} 枚",
      stat_current: "現在の容量",
      stat_partial: "{{n}} 件中 {{k}} 件が判明",
      stat_total: "合計",
      stat_after: "最適化後",
      stat_projected: "推定",
      stat_no_baseline: "初回実行後に表示",
      stat_saving: "削減率",
      stat_your_avg: "あなたの平均",
      stat_no_data: "データなし",
      stat_saved_total: "これまでの削減",
      stat_n_ops: "{{n}} 枚",
      processing_title: "画像を最適化中…",
      processing_prep: "準備中…",
      processing_done: "{{total}} 件中 {{done}} 件完了",
      processing_eta: "残り約 {{time}}",
      results_title: "最適化が完了しました",
      results_cancelled: "実行を中止しました",
      results_sub: "結果を確認してShopifyに適用してください",
      results_images: "画像",
      results_saved: "削減容量",
      results_avg: "平均",
      results_from_to: "変更前 → 変更後",
      info_vendor: "ベンダー",
      info_images: "画像",
      info_dims: "サイズ",
      info_weight: "容量",
      info_seo: "SEO",
      info_status: "状態",
      history_product: "商品",
    },
  },
  zh: {
    score_card: {
      label_not_run: "未执行",
    },
    batch: {
      credits_exhausted_toast: "积分已耗尽 ({{used}}/{{limit}}) — 购买更多积分或升级方案",
      credits_exhausted_title: "AI积分已耗尽",
      credits_exhausted_desc: "您已使用了每月{{limit}}个AI积分中的全部{{used}}个。购买更多积分或升级方案以继续生成内容。",
      credits_buy_cta: "购买更多积分",
      credits_upgrade_cta: "升级方案",
    },
    dashboard: {
      hero_cta_title: "发现您商店的SEO问题",
      hero_cta_desc: "开始完整分析：同步产品、计算SEO得分并在几分钟内获得360°审计。",
      hero_cta_btn: "开始免费分析",
      advisor_title: "AI Store Advisor",
      advisor_badge: "自动生成",
      section_opportunity: "AI Opportunity Score",
      hint_opportunity: "按可回收分数排序",
      opportunity_title: "AI Opportunity Score",
      opportunity_hint: "你的时间在哪里最值钱",
      opportunity_tooltip: "影响力是相对于你店铺中最大机会的数值，依据评分公式计算，并非对搜索排名的绝对承诺。",
      opp_impact: "影响力",
      opp_open: "打开",
      opp_issues: "{{n}} 个问题",
      opp_no_count: "全站",
      opp_meta_description: "Meta Description",
      opp_product_description: "产品描述",
      opp_alt_text: "ALT 文本",
      opp_performance: "速度优化",
      opp_structured_data: "结构化数据",
      opp_technical_seo: "技术 SEO",
      opp_ux: "用户体验",
      roi_very_high: "ROI 极高",
      roi_high: "ROI 高",
      roi_medium: "ROI 中等",
      roi_low: "ROI 低",
      insights_title: "AI Insights",
      insight_weakest: "{{dim}} 是限制你店铺得分的主要因素（{{value}}/100）。",
      insight_top_opportunity: "{{label}} 是目前影响力最大的改进项。",
      insight_strongest: "{{dim}} 已处于优秀状态（{{value}}/100）— 无需处理。",
      insight_alt: "图片可访问性还能提升：{{n}} 张图片仍无 ALT 文本。",
      insight_top_three: "解决前三项机会，总分约可提升 +{{n}} 分。",
      advisor_strong: "你的店铺技术状况良好",
      advisor_weak_open: "你的店铺在多个方面还有提升空间",
      advisor_blocked: "但目录得分（{{score}}/100）受限于",
      advisor_no_desc: "个产品缺少描述",
      advisor_no_meta: "个产品缺少 meta description",
      advisor_no_alt: "张图片缺少 ALT 文本",
      advisor_advice: "从这里入手至少能带来 +{{gain}} 分目录得分",
      advisor_clean: "目录已无结构性缺口 — 继续保持。",
      advisor_and: "和",
      advisor_cta: "从这项开始",
      advisor_great_title: "做得好 — 你的店铺已优化",
      advisor_great_sub: "已无结构性缺口。下次改动后重新运行审计以保持现状。",
      section_quickwins: "AI 推荐的快速优化",
      hint_quickwins: "按得分影响排序",
      priority_high: "高",
      priority_medium: "中",
      priority_low: "低",
      gain_tooltip: "依据评分公式得出的目录得分最小增幅。生成内容通常会进一步提升。",
      eta_tooltip: "根据实际处理速度估算",
      eta_seconds: "{{n}}秒",
      eta_minutes: "{{n}} 分钟",
      n_credits: "{{n}} 积分",
      no_credits: "不消耗积分",
      fix_btn: "修复",
      dim_technical: "技术 SEO",
      dim_ux: "UX",
      dim_trust: "信任度",
      dim_performance: "性能",
      dim_catalog: "目录",
      perf_load: "加载时间",
      perf_weight: "页面体积",
      perf_lazy: "懒加载图片",
      perf_all: "全部",
      perf_target: "目标",
      credits_unlimited: "无限制",
      credits_left: "剩余 {{n}} 积分",
      credits_exhausted: "月度积分已用完",
      credits_buy: "获取更多积分",
      forecast: "按当前速度约 {{n}}/月",
      forecast_tooltip: "根据安装以来的用量推算",
      activity_empty: "暂无活动",
      activity_fields: "个字段",
      time_now: "刚刚",
      time_min: "{{n}} 分钟前",
      time_hour: "{{n}} 小时前",
      time_day: "{{n}} 天前",
      qw_missing_description_title: "{{n}} 个产品缺少描述",
      qw_missing_description_desc: "空描述不利于 SEO，用 AI 生成吧。",
      qw_missing_meta_description_title: "{{n}} 个产品缺少 meta description",
      qw_missing_meta_description_desc: "用 AI 生成 SEO meta description，提升搜索结果点击率。",
      qw_missing_alt_text_title: "{{n}} 张图片缺少 ALT 文本",
      qw_missing_alt_text_desc: "为产品图片添加 ALT 文本，改善 SEO 与可访问性。",
      qw_missing_product_image_title: "{{n}} 个产品没有图片",
      qw_missing_product_image_desc: "没有图片的产品转化率低得多，添加一张吧。",
    },
    onboarding: {
      welcome_title: "欢迎使用 AI Optimizer 🎉",
      done_title: "分析完成 ✅",
      running_title: "分析进行中…",
      store_connected: "商店 {{domain}} 连接成功。",
      skip_label: "跳过",
      intro_text: "让我们自动分析您的商店，向您展示真实的SEO问题及解决方案。",
      step1_title: "产品同步",
      step1_sub: "从 Shopify 导入目录",
      step2_title: "产品 SEO 分析",
      step2_sub: "每个产品的 SEO 得分",
      step3_title: "网站审计 360°",
      step3_sub: "技术SEO、UX、信任度、性能",
      time_estimate: "预计时间：根据目录大小需1–3分钟。",
      start_btn: "开始免费分析",
      skip_btn: "稍后再说 — 从仪表板继续",
      error_fallback: "发生了错误。请从仪表板重试。",
      retry_btn: "重试",
      products_label: "个产品",
      scanning: "扫描中…",
      no_close: "分析期间请勿关闭此窗口",
      store_score_label: "商店评分",
      done_text: "仪表板现已填充真实数据。发现问题并开始优化。",
      see_results_btn: "查看结果",
    },
    content: {
      studio_title: "AI Content Studio",
      editor_pill: "AI 编辑器",
      current_version: "当前版本",
      ai_suggestion: "AI 建议",
      generate_ai_btn: "AI 生成",
      regenerate_btn: "重新生成",
      generate_field_title: "用 AI 生成此字段",
      apply_to_shopify: "应用到 Shopify",
      diff_legend: "高亮＝AI 新增或修改的内容",
      unsaved_suggestions: "{{n}} 条 AI 建议",
      field_limit: "建议最多 {{n}} 字符",
      last_published: "最近发布",
      empty_title: "选择一个项目开始",
      stat_seo: "SEO 得分",
      stat_readability: "可读性",
      stat_words: "字数",
      stat_keywords: "关键词",
      stat_fields: "字段",
      stat_not_analyzed: "未分析",
      stat_wps: "每句 {{n}} 词",
      stat_no_text: "无文本",
      stat_in_description: "描述中",
      stat_found: "已找到",
      stat_completed: "已完成",
      read_easy: "简单",
      read_medium: "中等",
      read_complex: "复杂",
    },
    transl: {
      studio_title: "AI Translation Studio",
      preview_pill: "翻译预览",
      preview_hint: "这是将被翻译的源内容",
      from: "源语言",
      to: "目标语言",
      current: "当前",
      original: "原文",
      ai_translation: "AI 翻译",
      ai_working: "AI 正在翻译…",
      preparing: "准备中…",
      progress_line: "{{total}} 项中的 {{done}} 项 · 每项 {{fields}} 个字段",
      translate_n: "翻译 {{n}} 项",
      translate_page: "将 {{n}} 项翻译为{{lang}}",
      goto_page: "已选 {{n}} 项 — 前往其页面",
      select_all_fields: "全选",
      deselect_fields: "取消选择",
      badge_translated: "已翻译",
      not_selected: "未选择",
      empty_field: "为空 — 将跳过",
      loading_detail: "正在加载内容…",
      empty_title: "选择一项进行预览",
      n_items: "{{n}} 项",
      n_fields: "{{n}} 个字段",
      stat_selected: "已选择",
      stat_target: "目标语言",
      stat_from: "源自{{lang}}",
      stat_fields: "字段",
      stat_per_item: "每项",
      stat_credits: "预计积分",
      stat_credits_sub: "每项 1 分 · 缓存免费",
      stat_credits_na: "不计费",
      stat_time: "预计时间",
      stat_time_sub: "约",
      note_fields: "SEO 字段单独翻译",
      note_cache: "已缓存 — 重复运行免费",
      note_review: "发布前请检查",
    },
    images: {
      studio_pill: "对比工作台",
      result_title: "优化结果",
      result_sub: "应用到 Shopify 以保留优化效果",
      result_grew_title: "这张图片变大了",
      result_grew_sub: "原图小于目标尺寸，缩放导致其被放大",
      result_before: "之前",
      result_after: "之后",
      result_added: "增加",
      result_extra: "额外体积",
      result_freed: "已释放",
      result_output: "输出",
      result_no_compress: "不压缩",
      results_processed: "已处理",
      results_freed: "已释放",
      results_per_image: "每张图片",
      results_was: "原为 {{size}}",
      slider_fullscreen: "打开全屏",
      info_pixels: "像素",
      info_original: "原图",
      info_out_of: "满分 100",
      info_awaiting_apply: "等待应用",
      info_state: "优化",
      status_todo: "待优化",
      stat_not_scored: "未评分",
      cta_n_images: "{{n}} 张图片",
      cta_saving: "约节省 {{size}}",
      matches_in_block: "{{matches}} 项匹配 · 已扫描 {{total}} 中的 {{scanned}}",
      block_info: "第 {{page}}/{{total}} 块 · 每块 {{size}} 个产品",
      client_filter_note: "体积、方向和状态在浏览器中计算，因此只筛选此处加载的区块，而非整个目录。点击「下一页」可继续扫描。",
      meta_loading: "正在读取另外 {{n}} 张图片 — 计数仍在稳定中",
      meta_unresolved: "{{n}} 项被排除：无法获取尺寸",
      empty_title: "选择一个产品进行对比",
      slider_hint: "拖动滑块进行对比",
      recommended: "推荐",
      size_unknown: "体积未知",
      badge_optimized: "已优化",
      quality_small: "更小的文件",
      quality_best: "最佳质量",
      output_dims: "输出：{{dims}} px",
      output_quality: "质量 {{q}}%",
      saved_label: "已节省",
      cta_est_saving: "约节省 {{size}} · 不消耗 AI 积分",
      cta_free: "不消耗 AI 积分",
      stat_selected: "已选择",
      stat_n_images: "{{n}} 张图片",
      stat_current: "当前体积",
      stat_partial: "{{n}} 中已知 {{k}}",
      stat_total: "总计",
      stat_after: "优化后",
      stat_projected: "预计",
      stat_no_baseline: "首次运行后显示",
      stat_saving: "节省",
      stat_your_avg: "你的平均值",
      stat_no_data: "暂无数据",
      stat_saved_total: "累计节省",
      stat_n_ops: "{{n}} 张图片",
      processing_title: "正在优化图片…",
      processing_prep: "准备中…",
      processing_done: "已完成 {{total}} 中的 {{done}}",
      processing_eta: "剩余约 {{time}}",
      results_title: "优化完成",
      results_cancelled: "已停止运行",
      results_sub: "查看结果，然后应用到 Shopify",
      results_images: "图片",
      results_saved: "释放空间",
      results_avg: "平均",
      results_from_to: "从 → 到",
      info_vendor: "供应商",
      info_images: "图片",
      info_dims: "尺寸",
      info_weight: "体积",
      info_seo: "SEO",
      info_status: "状态",
      history_product: "产品",
    },
  },
};

export default extraTranslations;
